/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SafetyRouteImport } from './routes/safety'
import { Route as RemindersPrintViewRouteImport } from './routes/reminders-print-view'
import { Route as RemindersRouteImport } from './routes/reminders'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PaymentRouteImport } from './routes/payment'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InfographicRouteImport } from './routes/infographic'
import { Route as HomeRouteImport } from './routes/home'
import { Route as Happy_birthdayRouteImport } from './routes/happy_birthday'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ForgotRouteImport } from './routes/forgot'
import { Route as Email_settingsRouteImport } from './routes/email_settings'
import { Route as EmailVerifyRouteImport } from './routes/email-verify'
import { Route as EmailLinkRouteImport } from './routes/email-link'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CompanyRouteImport } from './routes/company'
import { Route as Change_passwordRouteImport } from './routes/change_password'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as Address_bookRouteImport } from './routes/address_book'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as NameIndexRouteImport } from './routes/name/index'
import { Route as MycardsIndexRouteImport } from './routes/mycards/index'
import { Route as LinkedIndexRouteImport } from './routes/linked/index'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as FaqIndexRouteImport } from './routes/faq/index'
import { Route as CardsIndexRouteImport } from './routes/cards/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as SharesTokenRouteImport } from './routes/shares.$token'
import { Route as SSignTokenRouteImport } from './routes/s/$signToken'
import { Route as RemindersHolidayRouteImport } from './routes/reminders_.holiday'
import { Route as RemindersAddRouteImport } from './routes/reminders_.add'
import { Route as NameNameRouteImport } from './routes/name/$name'
import { Route as MycardsTypeRouteImport } from './routes/mycards/$type'
import { Route as ListsNewRouteImport } from './routes/lists/new'
import { Route as ListsTokenRouteImport } from './routes/lists/$token'
import { Route as HolidayBrowseRouteImport } from './routes/holiday/browse'
import { Route as GiftSdkHostRouteImport } from './routes/gift.sdk-host'
import { Route as DobTokenRouteImport } from './routes/dob/$token'
import { Route as ContactsImportRouteImport } from './routes/contacts/import'
import { Route as CardsBrowseRouteImport } from './routes/cards/browse'
import { Route as CardsSplatRouteImport } from './routes/cards/$'
import { Route as CardCreateRouteImport } from './routes/card/create'
import { Route as BirthdayBrowseRouteImport } from './routes/birthday/browse'
import { Route as BillingReturnRouteImport } from './routes/billing/return'
import { Route as BdayMagicRouteImport } from './routes/bday/$magic'
import { Route as Bd7MagicRouteImport } from './routes/bd7/$magic'
import { Route as Bd6MagicRouteImport } from './routes/bd6/$magic'
import { Route as Bd5MagicRouteImport } from './routes/bd5/$magic'
import { Route as Bd4MagicRouteImport } from './routes/bd4/$magic'
import { Route as AnniversaryGiftRouteImport } from './routes/anniversary/gift'
import { Route as AnniversaryBrowseRouteImport } from './routes/anniversary/browse'
import { Route as AdminWebsocketsRouteImport } from './routes/admin/websockets'
import { Route as AdminVideosRouteImport } from './routes/admin/videos'
import { Route as AdminVerifyRouteImport } from './routes/admin/verify'
import { Route as AdminTrendingRouteImport } from './routes/admin/trending'
import { Route as AdminTagsRouteImport } from './routes/admin/tags'
import { Route as AdminSuppressionsRouteImport } from './routes/admin/suppressions'
import { Route as AdminSupportRouteImport } from './routes/admin/support'
import { Route as AdminServersRouteImport } from './routes/admin/servers'
import { Route as AdminSentryRouteImport } from './routes/admin/sentry'
import { Route as AdminScriptsRouteImport } from './routes/admin/scripts'
import { Route as AdminSchemaRouteImport } from './routes/admin/schema'
import { Route as AdminSchedulerRouteImport } from './routes/admin/scheduler'
import { Route as AdminRecoRouteImport } from './routes/admin/reco'
import { Route as AdminQueryRouteImport } from './routes/admin/query'
import { Route as AdminPopularNamesRouteImport } from './routes/admin/popular-names'
import { Route as AdminOfflinePaymentsRouteImport } from './routes/admin/offline-payments'
import { Route as AdminModerationRouteImport } from './routes/admin/moderation'
import { Route as AdminEmailLookupRouteImport } from './routes/admin/email-lookup'
import { Route as AdminDeliverabilityRouteImport } from './routes/admin/deliverability'
import { Route as AdminDatabaseDdlRouteImport } from './routes/admin/database-ddl'
import { Route as AdminCreatorsRouteImport } from './routes/admin/creators'
import { Route as AdminBillingPlansRouteImport } from './routes/admin/billing-plans'
import { Route as AdminAvatarsRouteImport } from './routes/admin/avatars'
import { Route as AdminAppVersionRouteImport } from './routes/admin/app-version'
import { Route as AdminApiRouteImport } from './routes/admin/api'
import { Route as AdminAiRouteImport } from './routes/admin/ai'
import { Route as AccountCancelRouteImport } from './routes/account_.cancel'
import { Route as AccountBillingRouteImport } from './routes/account_.billing'
import { Route as HelpSectionIndexRouteImport } from './routes/help/$section/index'
import { Route as FaqCategoryIndexRouteImport } from './routes/faq/$category/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminStickersIndexRouteImport } from './routes/admin/stickers/index'
import { Route as AdminSmsIndexRouteImport } from './routes/admin/sms/index'
import { Route as AdminSigningIndexRouteImport } from './routes/admin/signing/index'
import { Route as AdminSeedDataIndexRouteImport } from './routes/admin/seed-data/index'
import { Route as AdminReportsIndexRouteImport } from './routes/admin/reports/index'
import { Route as AdminPushIndexRouteImport } from './routes/admin/push/index'
import { Route as AdminOccasionsIndexRouteImport } from './routes/admin/occasions/index'
import { Route as AdminNewslettersIndexRouteImport } from './routes/admin/newsletters/index'
import { Route as AdminModeratedImagesIndexRouteImport } from './routes/admin/moderated-images/index'
import { Route as AdminMediaIndexRouteImport } from './routes/admin/media/index'
import { Route as AdminKnowledgeIndexRouteImport } from './routes/admin/knowledge/index'
import { Route as AdminImagesIndexRouteImport } from './routes/admin/images/index'
import { Route as AdminGiftCardsIndexRouteImport } from './routes/admin/gift-cards/index'
import { Route as AdminEmailIndexRouteImport } from './routes/admin/email/index'
import { Route as AdminDocsIndexRouteImport } from './routes/admin/docs/index'
import { Route as AdminDisputesIndexRouteImport } from './routes/admin/disputes/index'
import { Route as AdminDispatchMonitorIndexRouteImport } from './routes/admin/dispatch-monitor/index'
import { Route as AdminCountriesIndexRouteImport } from './routes/admin/countries/index'
import { Route as AdminContactsIndexRouteImport } from './routes/admin/contacts/index'
import { Route as AdminCodesIndexRouteImport } from './routes/admin/codes/index'
import { Route as AdminCategoriesIndexRouteImport } from './routes/admin/categories/index'
import { Route as AdminCardsIndexRouteImport } from './routes/admin/cards/index'
import { Route as AdminBackgroundsIndexRouteImport } from './routes/admin/backgrounds/index'
import { Route as SupportTicketTokenRouteImport } from './routes/support/ticket.$token'
import { Route as RemindersHolidayAddRouteImport } from './routes/reminders_.holiday_.add'
import { Route as RemindersBirthdayMoreRouteImport } from './routes/reminders_.birthday_.more'
import { Route as RemindersBirthdayAddRouteImport } from './routes/reminders_.birthday_.add'
import { Route as ListsViewIdRouteImport } from './routes/lists/view.$id'
import { Route as LinkedRequestsIdRouteImport } from './routes/linked/requests.$id'
import { Route as HelpSectionArticleRouteImport } from './routes/help/$section/$article'
import { Route as FaqCategoryArticleRouteImport } from './routes/faq/$category/$article'
import { Route as CopyReadSlugRouteImport } from './routes/copy/read/$slug'
import { Route as CardViewCardIdRouteImport } from './routes/card/view/$cardId'
import { Route as CardSendCreateRouteImport } from './routes/card/send/create'
import { Route as CardReadSlugRouteImport } from './routes/card/read/$slug'
import { Route as BirthdayRequestHowtoRouteImport } from './routes/birthday_.request_.howto'
import { Route as AdminUsersIdRouteImport } from './routes/admin/users/$id'
import { Route as AdminSeedDataTypeRouteImport } from './routes/admin/seed-data/$type'
import { Route as AdminReportsExploreRouteImport } from './routes/admin/reports/explore'
import { Route as AdminPushIdRouteImport } from './routes/admin/push/$id'
import { Route as AdminOccasionsIdRouteImport } from './routes/admin/occasions/$id'
import { Route as AdminNewslettersIssueIdRouteImport } from './routes/admin/newsletters/$issueId'
import { Route as AdminModerationReportIdRouteImport } from './routes/admin/moderation.$reportId'
import { Route as AdminModeratedImagesIdRouteImport } from './routes/admin/moderated-images/$id'
import { Route as AdminMediaIdRouteImport } from './routes/admin/media/$id'
import { Route as AdminImagesIdRouteImport } from './routes/admin/images/$id'
import { Route as AdminGiftCardsGiftCardIdRouteImport } from './routes/admin/gift-cards/$giftCardId'
import { Route as AdminEmailIdRouteImport } from './routes/admin/email/$id'
import { Route as AdminEmailAuditIdRouteImport } from './routes/admin/email-audit/$id'
import { Route as AdminDisputesIdRouteImport } from './routes/admin/disputes/$id'
import { Route as AdminContactsIdRouteImport } from './routes/admin/contacts/$id'
import { Route as AdminCodesCodeIdRouteImport } from './routes/admin/codes/$codeId'
import { Route as AdminCategoriesIdRouteImport } from './routes/admin/categories/$id'
import { Route as AdminCardsIdRouteImport } from './routes/admin/cards/$id'
import { Route as AdminBackgroundsIdRouteImport } from './routes/admin/backgrounds/$id'
import { Route as RemindersBirthdayAddManualRouteImport } from './routes/reminders_.birthday_.add_.manual'
import { Route as CardViewCardIdSlugRouteImport } from './routes/card/view/$cardId_.$slug'
import { Route as CardSignViewSlugRouteImport } from './routes/card/sign/view/$slug'
import { Route as CardSignEditSlugRouteImport } from './routes/card/sign/edit/$slug'
import { Route as CardShareViewSlugRouteImport } from './routes/card/share/view/$slug'
import { Route as CardSendViewSlugRouteImport } from './routes/card/send/view/$slug'
import { Route as AdminReportsDSlugRouteImport } from './routes/admin/reports/d/$slug'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SafetyRoute = SafetyRouteImport.update({
  id: '/safety',
  path: '/safety',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersPrintViewRoute = RemindersPrintViewRouteImport.update({
  id: '/reminders-print-view',
  path: '/reminders-print-view',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersRoute = RemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentRoute = PaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InfographicRoute = InfographicRouteImport.update({
  id: '/infographic',
  path: '/infographic',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const Happy_birthdayRoute = Happy_birthdayRouteImport.update({
  id: '/happy_birthday',
  path: '/happy_birthday',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotRoute = ForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const Email_settingsRoute = Email_settingsRouteImport.update({
  id: '/email_settings',
  path: '/email_settings',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailVerifyRoute = EmailVerifyRouteImport.update({
  id: '/email-verify',
  path: '/email-verify',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailLinkRoute = EmailLinkRouteImport.update({
  id: '/email-link',
  path: '/email-link',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CompanyRoute = CompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => rootRouteImport,
} as any)
const Change_passwordRoute = Change_passwordRouteImport.update({
  id: '/change_password',
  path: '/change_password',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const Address_bookRoute = Address_bookRouteImport.update({
  id: '/address_book',
  path: '/address_book',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => rootRouteImport,
} as any)
const NameIndexRoute = NameIndexRouteImport.update({
  id: '/name/',
  path: '/name/',
  getParentRoute: () => rootRouteImport,
} as any)
const MycardsIndexRoute = MycardsIndexRouteImport.update({
  id: '/mycards/',
  path: '/mycards/',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkedIndexRoute = LinkedIndexRouteImport.update({
  id: '/linked/',
  path: '/linked/',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpIndexRoute = HelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqIndexRoute = FaqIndexRouteImport.update({
  id: '/faq/',
  path: '/faq/',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsIndexRoute = CardsIndexRouteImport.update({
  id: '/cards/',
  path: '/cards/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const SharesTokenRoute = SharesTokenRouteImport.update({
  id: '/shares/$token',
  path: '/shares/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SSignTokenRoute = SSignTokenRouteImport.update({
  id: '/s/$signToken',
  path: '/s/$signToken',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersHolidayRoute = RemindersHolidayRouteImport.update({
  id: '/reminders_/holiday',
  path: '/reminders/holiday',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersAddRoute = RemindersAddRouteImport.update({
  id: '/reminders_/add',
  path: '/reminders/add',
  getParentRoute: () => rootRouteImport,
} as any)
const NameNameRoute = NameNameRouteImport.update({
  id: '/name/$name',
  path: '/name/$name',
  getParentRoute: () => rootRouteImport,
} as any)
const MycardsTypeRoute = MycardsTypeRouteImport.update({
  id: '/mycards/$type',
  path: '/mycards/$type',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsNewRoute = ListsNewRouteImport.update({
  id: '/lists/new',
  path: '/lists/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsTokenRoute = ListsTokenRouteImport.update({
  id: '/lists/$token',
  path: '/lists/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const HolidayBrowseRoute = HolidayBrowseRouteImport.update({
  id: '/holiday/browse',
  path: '/holiday/browse',
  getParentRoute: () => rootRouteImport,
} as any)
const GiftSdkHostRoute = GiftSdkHostRouteImport.update({
  id: '/gift/sdk-host',
  path: '/gift/sdk-host',
  getParentRoute: () => rootRouteImport,
} as any)
const DobTokenRoute = DobTokenRouteImport.update({
  id: '/dob/$token',
  path: '/dob/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsImportRoute = ContactsImportRouteImport.update({
  id: '/contacts/import',
  path: '/contacts/import',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsBrowseRoute = CardsBrowseRouteImport.update({
  id: '/cards/browse',
  path: '/cards/browse',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsSplatRoute = CardsSplatRouteImport.update({
  id: '/cards/$',
  path: '/cards/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CardCreateRoute = CardCreateRouteImport.update({
  id: '/card/create',
  path: '/card/create',
  getParentRoute: () => rootRouteImport,
} as any)
const BirthdayBrowseRoute = BirthdayBrowseRouteImport.update({
  id: '/birthday/browse',
  path: '/birthday/browse',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingReturnRoute = BillingReturnRouteImport.update({
  id: '/billing/return',
  path: '/billing/return',
  getParentRoute: () => rootRouteImport,
} as any)
const BdayMagicRoute = BdayMagicRouteImport.update({
  id: '/bday/$magic',
  path: '/bday/$magic',
  getParentRoute: () => rootRouteImport,
} as any)
const Bd7MagicRoute = Bd7MagicRouteImport.update({
  id: '/bd7/$magic',
  path: '/bd7/$magic',
  getParentRoute: () => rootRouteImport,
} as any)
const Bd6MagicRoute = Bd6MagicRouteImport.update({
  id: '/bd6/$magic',
  path: '/bd6/$magic',
  getParentRoute: () => rootRouteImport,
} as any)
const Bd5MagicRoute = Bd5MagicRouteImport.update({
  id: '/bd5/$magic',
  path: '/bd5/$magic',
  getParentRoute: () => rootRouteImport,
} as any)
const Bd4MagicRoute = Bd4MagicRouteImport.update({
  id: '/bd4/$magic',
  path: '/bd4/$magic',
  getParentRoute: () => rootRouteImport,
} as any)
const AnniversaryGiftRoute = AnniversaryGiftRouteImport.update({
  id: '/anniversary/gift',
  path: '/anniversary/gift',
  getParentRoute: () => rootRouteImport,
} as any)
const AnniversaryBrowseRoute = AnniversaryBrowseRouteImport.update({
  id: '/anniversary/browse',
  path: '/anniversary/browse',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminWebsocketsRoute = AdminWebsocketsRouteImport.update({
  id: '/admin/websockets',
  path: '/admin/websockets',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVideosRoute = AdminVideosRouteImport.update({
  id: '/admin/videos',
  path: '/admin/videos',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminVerifyRoute = AdminVerifyRouteImport.update({
  id: '/admin/verify',
  path: '/admin/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTrendingRoute = AdminTrendingRouteImport.update({
  id: '/admin/trending',
  path: '/admin/trending',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTagsRoute = AdminTagsRouteImport.update({
  id: '/admin/tags',
  path: '/admin/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSuppressionsRoute = AdminSuppressionsRouteImport.update({
  id: '/admin/suppressions',
  path: '/admin/suppressions',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSupportRoute = AdminSupportRouteImport.update({
  id: '/admin/support',
  path: '/admin/support',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminServersRoute = AdminServersRouteImport.update({
  id: '/admin/servers',
  path: '/admin/servers',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSentryRoute = AdminSentryRouteImport.update({
  id: '/admin/sentry',
  path: '/admin/sentry',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminScriptsRoute = AdminScriptsRouteImport.update({
  id: '/admin/scripts',
  path: '/admin/scripts',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSchemaRoute = AdminSchemaRouteImport.update({
  id: '/admin/schema',
  path: '/admin/schema',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSchedulerRoute = AdminSchedulerRouteImport.update({
  id: '/admin/scheduler',
  path: '/admin/scheduler',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRecoRoute = AdminRecoRouteImport.update({
  id: '/admin/reco',
  path: '/admin/reco',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminQueryRoute = AdminQueryRouteImport.update({
  id: '/admin/query',
  path: '/admin/query',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPopularNamesRoute = AdminPopularNamesRouteImport.update({
  id: '/admin/popular-names',
  path: '/admin/popular-names',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOfflinePaymentsRoute = AdminOfflinePaymentsRouteImport.update({
  id: '/admin/offline-payments',
  path: '/admin/offline-payments',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModerationRoute = AdminModerationRouteImport.update({
  id: '/admin/moderation',
  path: '/admin/moderation',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailLookupRoute = AdminEmailLookupRouteImport.update({
  id: '/admin/email-lookup',
  path: '/admin/email-lookup',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDeliverabilityRoute = AdminDeliverabilityRouteImport.update({
  id: '/admin/deliverability',
  path: '/admin/deliverability',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDatabaseDdlRoute = AdminDatabaseDdlRouteImport.update({
  id: '/admin/database-ddl',
  path: '/admin/database-ddl',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCreatorsRoute = AdminCreatorsRouteImport.update({
  id: '/admin/creators',
  path: '/admin/creators',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingPlansRoute = AdminBillingPlansRouteImport.update({
  id: '/admin/billing-plans',
  path: '/admin/billing-plans',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAvatarsRoute = AdminAvatarsRouteImport.update({
  id: '/admin/avatars',
  path: '/admin/avatars',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAppVersionRoute = AdminAppVersionRouteImport.update({
  id: '/admin/app-version',
  path: '/admin/app-version',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminApiRoute = AdminApiRouteImport.update({
  id: '/admin/api',
  path: '/admin/api',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiRoute = AdminAiRouteImport.update({
  id: '/admin/ai',
  path: '/admin/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountCancelRoute = AccountCancelRouteImport.update({
  id: '/account_/cancel',
  path: '/account/cancel',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountBillingRoute = AccountBillingRouteImport.update({
  id: '/account_/billing',
  path: '/account/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSectionIndexRoute = HelpSectionIndexRouteImport.update({
  id: '/help/$section/',
  path: '/help/$section/',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqCategoryIndexRoute = FaqCategoryIndexRouteImport.update({
  id: '/faq/$category/',
  path: '/faq/$category/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminStickersIndexRoute = AdminStickersIndexRouteImport.update({
  id: '/admin/stickers/',
  path: '/admin/stickers/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSmsIndexRoute = AdminSmsIndexRouteImport.update({
  id: '/admin/sms/',
  path: '/admin/sms/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSigningIndexRoute = AdminSigningIndexRouteImport.update({
  id: '/admin/signing/',
  path: '/admin/signing/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSeedDataIndexRoute = AdminSeedDataIndexRouteImport.update({
  id: '/admin/seed-data/',
  path: '/admin/seed-data/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsIndexRoute = AdminReportsIndexRouteImport.update({
  id: '/admin/reports/',
  path: '/admin/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPushIndexRoute = AdminPushIndexRouteImport.update({
  id: '/admin/push/',
  path: '/admin/push/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOccasionsIndexRoute = AdminOccasionsIndexRouteImport.update({
  id: '/admin/occasions/',
  path: '/admin/occasions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNewslettersIndexRoute = AdminNewslettersIndexRouteImport.update({
  id: '/admin/newsletters/',
  path: '/admin/newsletters/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModeratedImagesIndexRoute =
  AdminModeratedImagesIndexRouteImport.update({
    id: '/admin/moderated-images/',
    path: '/admin/moderated-images/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminMediaIndexRoute = AdminMediaIndexRouteImport.update({
  id: '/admin/media/',
  path: '/admin/media/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminKnowledgeIndexRoute = AdminKnowledgeIndexRouteImport.update({
  id: '/admin/knowledge/',
  path: '/admin/knowledge/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminImagesIndexRoute = AdminImagesIndexRouteImport.update({
  id: '/admin/images/',
  path: '/admin/images/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGiftCardsIndexRoute = AdminGiftCardsIndexRouteImport.update({
  id: '/admin/gift-cards/',
  path: '/admin/gift-cards/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailIndexRoute = AdminEmailIndexRouteImport.update({
  id: '/admin/email/',
  path: '/admin/email/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDocsIndexRoute = AdminDocsIndexRouteImport.update({
  id: '/admin/docs/',
  path: '/admin/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDisputesIndexRoute = AdminDisputesIndexRouteImport.update({
  id: '/admin/disputes/',
  path: '/admin/disputes/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDispatchMonitorIndexRoute =
  AdminDispatchMonitorIndexRouteImport.update({
    id: '/admin/dispatch-monitor/',
    path: '/admin/dispatch-monitor/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminCountriesIndexRoute = AdminCountriesIndexRouteImport.update({
  id: '/admin/countries/',
  path: '/admin/countries/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContactsIndexRoute = AdminContactsIndexRouteImport.update({
  id: '/admin/contacts/',
  path: '/admin/contacts/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCodesIndexRoute = AdminCodesIndexRouteImport.update({
  id: '/admin/codes/',
  path: '/admin/codes/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCategoriesIndexRoute = AdminCategoriesIndexRouteImport.update({
  id: '/admin/categories/',
  path: '/admin/categories/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCardsIndexRoute = AdminCardsIndexRouteImport.update({
  id: '/admin/cards/',
  path: '/admin/cards/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBackgroundsIndexRoute = AdminBackgroundsIndexRouteImport.update({
  id: '/admin/backgrounds/',
  path: '/admin/backgrounds/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportTicketTokenRoute = SupportTicketTokenRouteImport.update({
  id: '/support/ticket/$token',
  path: '/support/ticket/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersHolidayAddRoute = RemindersHolidayAddRouteImport.update({
  id: '/reminders_/holiday_/add',
  path: '/reminders/holiday/add',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersBirthdayMoreRoute = RemindersBirthdayMoreRouteImport.update({
  id: '/reminders_/birthday_/more',
  path: '/reminders/birthday/more',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersBirthdayAddRoute = RemindersBirthdayAddRouteImport.update({
  id: '/reminders_/birthday_/add',
  path: '/reminders/birthday/add',
  getParentRoute: () => rootRouteImport,
} as any)
const ListsViewIdRoute = ListsViewIdRouteImport.update({
  id: '/lists/view/$id',
  path: '/lists/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkedRequestsIdRoute = LinkedRequestsIdRouteImport.update({
  id: '/linked/requests/$id',
  path: '/linked/requests/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpSectionArticleRoute = HelpSectionArticleRouteImport.update({
  id: '/help/$section/$article',
  path: '/help/$section/$article',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqCategoryArticleRoute = FaqCategoryArticleRouteImport.update({
  id: '/faq/$category/$article',
  path: '/faq/$category/$article',
  getParentRoute: () => rootRouteImport,
} as any)
const CopyReadSlugRoute = CopyReadSlugRouteImport.update({
  id: '/copy/read/$slug',
  path: '/copy/read/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CardViewCardIdRoute = CardViewCardIdRouteImport.update({
  id: '/card/view/$cardId',
  path: '/card/view/$cardId',
  getParentRoute: () => rootRouteImport,
} as any)
const CardSendCreateRoute = CardSendCreateRouteImport.update({
  id: '/card/send/create',
  path: '/card/send/create',
  getParentRoute: () => rootRouteImport,
} as any)
const CardReadSlugRoute = CardReadSlugRouteImport.update({
  id: '/card/read/$slug',
  path: '/card/read/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const BirthdayRequestHowtoRoute = BirthdayRequestHowtoRouteImport.update({
  id: '/birthday_/request_/howto',
  path: '/birthday/request/howto',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIdRoute = AdminUsersIdRouteImport.update({
  id: '/admin/users/$id',
  path: '/admin/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSeedDataTypeRoute = AdminSeedDataTypeRouteImport.update({
  id: '/admin/seed-data/$type',
  path: '/admin/seed-data/$type',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsExploreRoute = AdminReportsExploreRouteImport.update({
  id: '/admin/reports/explore',
  path: '/admin/reports/explore',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPushIdRoute = AdminPushIdRouteImport.update({
  id: '/admin/push/$id',
  path: '/admin/push/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOccasionsIdRoute = AdminOccasionsIdRouteImport.update({
  id: '/admin/occasions/$id',
  path: '/admin/occasions/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminNewslettersIssueIdRoute = AdminNewslettersIssueIdRouteImport.update({
  id: '/admin/newsletters/$issueId',
  path: '/admin/newsletters/$issueId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminModerationReportIdRoute = AdminModerationReportIdRouteImport.update({
  id: '/$reportId',
  path: '/$reportId',
  getParentRoute: () => AdminModerationRoute,
} as any)
const AdminModeratedImagesIdRoute = AdminModeratedImagesIdRouteImport.update({
  id: '/admin/moderated-images/$id',
  path: '/admin/moderated-images/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminMediaIdRoute = AdminMediaIdRouteImport.update({
  id: '/admin/media/$id',
  path: '/admin/media/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminImagesIdRoute = AdminImagesIdRouteImport.update({
  id: '/admin/images/$id',
  path: '/admin/images/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminGiftCardsGiftCardIdRoute =
  AdminGiftCardsGiftCardIdRouteImport.update({
    id: '/admin/gift-cards/$giftCardId',
    path: '/admin/gift-cards/$giftCardId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminEmailIdRoute = AdminEmailIdRouteImport.update({
  id: '/admin/email/$id',
  path: '/admin/email/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEmailAuditIdRoute = AdminEmailAuditIdRouteImport.update({
  id: '/admin/email-audit/$id',
  path: '/admin/email-audit/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDisputesIdRoute = AdminDisputesIdRouteImport.update({
  id: '/admin/disputes/$id',
  path: '/admin/disputes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminContactsIdRoute = AdminContactsIdRouteImport.update({
  id: '/admin/contacts/$id',
  path: '/admin/contacts/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCodesCodeIdRoute = AdminCodesCodeIdRouteImport.update({
  id: '/admin/codes/$codeId',
  path: '/admin/codes/$codeId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCategoriesIdRoute = AdminCategoriesIdRouteImport.update({
  id: '/admin/categories/$id',
  path: '/admin/categories/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCardsIdRoute = AdminCardsIdRouteImport.update({
  id: '/admin/cards/$id',
  path: '/admin/cards/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBackgroundsIdRoute = AdminBackgroundsIdRouteImport.update({
  id: '/admin/backgrounds/$id',
  path: '/admin/backgrounds/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const RemindersBirthdayAddManualRoute =
  RemindersBirthdayAddManualRouteImport.update({
    id: '/reminders_/birthday_/add_/manual',
    path: '/reminders/birthday/add/manual',
    getParentRoute: () => rootRouteImport,
  } as any)
const CardViewCardIdSlugRoute = CardViewCardIdSlugRouteImport.update({
  id: '/card/view/$cardId_/$slug',
  path: '/card/view/$cardId/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CardSignViewSlugRoute = CardSignViewSlugRouteImport.update({
  id: '/card/sign/view/$slug',
  path: '/card/sign/view/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CardSignEditSlugRoute = CardSignEditSlugRouteImport.update({
  id: '/card/sign/edit/$slug',
  path: '/card/sign/edit/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CardShareViewSlugRoute = CardShareViewSlugRouteImport.update({
  id: '/card/share/view/$slug',
  path: '/card/share/view/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const CardSendViewSlugRoute = CardSendViewSlugRouteImport.update({
  id: '/card/send/view/$slug',
  path: '/card/send/view/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReportsDSlugRoute = AdminReportsDSlugRouteImport.update({
  id: '/admin/reports/d/$slug',
  path: '/admin/reports/d/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/address_book': typeof Address_bookRoute
  '/auth': typeof AuthRoute
  '/calendar': typeof CalendarRoute
  '/change_password': typeof Change_passwordRoute
  '/company': typeof CompanyRoute
  '/contact': typeof ContactRoute
  '/email-link': typeof EmailLinkRoute
  '/email-verify': typeof EmailVerifyRoute
  '/email_settings': typeof Email_settingsRoute
  '/forgot': typeof ForgotRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/happy_birthday': typeof Happy_birthdayRoute
  '/home': typeof HomeRoute
  '/infographic': typeof InfographicRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/payment': typeof PaymentRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reminders': typeof RemindersRoute
  '/reminders-print-view': typeof RemindersPrintViewRoute
  '/safety': typeof SafetyRoute
  '/team': typeof TeamRoute
  '/terms': typeof TermsRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/account/billing': typeof AccountBillingRoute
  '/account/cancel': typeof AccountCancelRoute
  '/admin/ai': typeof AdminAiRoute
  '/admin/api': typeof AdminApiRoute
  '/admin/app-version': typeof AdminAppVersionRoute
  '/admin/avatars': typeof AdminAvatarsRoute
  '/admin/billing-plans': typeof AdminBillingPlansRoute
  '/admin/creators': typeof AdminCreatorsRoute
  '/admin/database-ddl': typeof AdminDatabaseDdlRoute
  '/admin/deliverability': typeof AdminDeliverabilityRoute
  '/admin/email-lookup': typeof AdminEmailLookupRoute
  '/admin/moderation': typeof AdminModerationRouteWithChildren
  '/admin/offline-payments': typeof AdminOfflinePaymentsRoute
  '/admin/popular-names': typeof AdminPopularNamesRoute
  '/admin/query': typeof AdminQueryRoute
  '/admin/reco': typeof AdminRecoRoute
  '/admin/scheduler': typeof AdminSchedulerRoute
  '/admin/schema': typeof AdminSchemaRoute
  '/admin/scripts': typeof AdminScriptsRoute
  '/admin/sentry': typeof AdminSentryRoute
  '/admin/servers': typeof AdminServersRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/suppressions': typeof AdminSuppressionsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/trending': typeof AdminTrendingRoute
  '/admin/verify': typeof AdminVerifyRoute
  '/admin/videos': typeof AdminVideosRoute
  '/admin/websockets': typeof AdminWebsocketsRoute
  '/anniversary/browse': typeof AnniversaryBrowseRoute
  '/anniversary/gift': typeof AnniversaryGiftRoute
  '/bd4/$magic': typeof Bd4MagicRoute
  '/bd5/$magic': typeof Bd5MagicRoute
  '/bd6/$magic': typeof Bd6MagicRoute
  '/bd7/$magic': typeof Bd7MagicRoute
  '/bday/$magic': typeof BdayMagicRoute
  '/billing/return': typeof BillingReturnRoute
  '/birthday/browse': typeof BirthdayBrowseRoute
  '/card/create': typeof CardCreateRoute
  '/cards/$': typeof CardsSplatRoute
  '/cards/browse': typeof CardsBrowseRoute
  '/contacts/import': typeof ContactsImportRoute
  '/dob/$token': typeof DobTokenRoute
  '/gift/sdk-host': typeof GiftSdkHostRoute
  '/holiday/browse': typeof HolidayBrowseRoute
  '/lists/$token': typeof ListsTokenRoute
  '/lists/new': typeof ListsNewRoute
  '/mycards/$type': typeof MycardsTypeRoute
  '/name/$name': typeof NameNameRoute
  '/reminders/add': typeof RemindersAddRoute
  '/reminders/holiday': typeof RemindersHolidayRoute
  '/s/$signToken': typeof SSignTokenRoute
  '/shares/$token': typeof SharesTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/cards/': typeof CardsIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/help/': typeof HelpIndexRoute
  '/linked/': typeof LinkedIndexRoute
  '/mycards/': typeof MycardsIndexRoute
  '/name/': typeof NameIndexRoute
  '/support/': typeof SupportIndexRoute
  '/admin/backgrounds/$id': typeof AdminBackgroundsIdRoute
  '/admin/cards/$id': typeof AdminCardsIdRoute
  '/admin/categories/$id': typeof AdminCategoriesIdRoute
  '/admin/codes/$codeId': typeof AdminCodesCodeIdRoute
  '/admin/contacts/$id': typeof AdminContactsIdRoute
  '/admin/disputes/$id': typeof AdminDisputesIdRoute
  '/admin/email-audit/$id': typeof AdminEmailAuditIdRoute
  '/admin/email/$id': typeof AdminEmailIdRoute
  '/admin/gift-cards/$giftCardId': typeof AdminGiftCardsGiftCardIdRoute
  '/admin/images/$id': typeof AdminImagesIdRoute
  '/admin/media/$id': typeof AdminMediaIdRoute
  '/admin/moderated-images/$id': typeof AdminModeratedImagesIdRoute
  '/admin/moderation/$reportId': typeof AdminModerationReportIdRoute
  '/admin/newsletters/$issueId': typeof AdminNewslettersIssueIdRoute
  '/admin/occasions/$id': typeof AdminOccasionsIdRoute
  '/admin/push/$id': typeof AdminPushIdRoute
  '/admin/reports/explore': typeof AdminReportsExploreRoute
  '/admin/seed-data/$type': typeof AdminSeedDataTypeRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/birthday/request/howto': typeof BirthdayRequestHowtoRoute
  '/card/read/$slug': typeof CardReadSlugRoute
  '/card/send/create': typeof CardSendCreateRoute
  '/card/view/$cardId': typeof CardViewCardIdRoute
  '/copy/read/$slug': typeof CopyReadSlugRoute
  '/faq/$category/$article': typeof FaqCategoryArticleRoute
  '/help/$section/$article': typeof HelpSectionArticleRoute
  '/linked/requests/$id': typeof LinkedRequestsIdRoute
  '/lists/view/$id': typeof ListsViewIdRoute
  '/reminders/birthday/add': typeof RemindersBirthdayAddRoute
  '/reminders/birthday/more': typeof RemindersBirthdayMoreRoute
  '/reminders/holiday/add': typeof RemindersHolidayAddRoute
  '/support/ticket/$token': typeof SupportTicketTokenRoute
  '/admin/backgrounds/': typeof AdminBackgroundsIndexRoute
  '/admin/cards/': typeof AdminCardsIndexRoute
  '/admin/categories/': typeof AdminCategoriesIndexRoute
  '/admin/codes/': typeof AdminCodesIndexRoute
  '/admin/contacts/': typeof AdminContactsIndexRoute
  '/admin/countries/': typeof AdminCountriesIndexRoute
  '/admin/dispatch-monitor/': typeof AdminDispatchMonitorIndexRoute
  '/admin/disputes/': typeof AdminDisputesIndexRoute
  '/admin/docs/': typeof AdminDocsIndexRoute
  '/admin/email/': typeof AdminEmailIndexRoute
  '/admin/gift-cards/': typeof AdminGiftCardsIndexRoute
  '/admin/images/': typeof AdminImagesIndexRoute
  '/admin/knowledge/': typeof AdminKnowledgeIndexRoute
  '/admin/media/': typeof AdminMediaIndexRoute
  '/admin/moderated-images/': typeof AdminModeratedImagesIndexRoute
  '/admin/newsletters/': typeof AdminNewslettersIndexRoute
  '/admin/occasions/': typeof AdminOccasionsIndexRoute
  '/admin/push/': typeof AdminPushIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/seed-data/': typeof AdminSeedDataIndexRoute
  '/admin/signing/': typeof AdminSigningIndexRoute
  '/admin/sms/': typeof AdminSmsIndexRoute
  '/admin/stickers/': typeof AdminStickersIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/faq/$category/': typeof FaqCategoryIndexRoute
  '/help/$section/': typeof HelpSectionIndexRoute
  '/admin/reports/d/$slug': typeof AdminReportsDSlugRoute
  '/card/send/view/$slug': typeof CardSendViewSlugRoute
  '/card/share/view/$slug': typeof CardShareViewSlugRoute
  '/card/sign/edit/$slug': typeof CardSignEditSlugRoute
  '/card/sign/view/$slug': typeof CardSignViewSlugRoute
  '/card/view/$cardId/$slug': typeof CardViewCardIdSlugRoute
  '/reminders/birthday/add/manual': typeof RemindersBirthdayAddManualRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/address_book': typeof Address_bookRoute
  '/auth': typeof AuthRoute
  '/calendar': typeof CalendarRoute
  '/change_password': typeof Change_passwordRoute
  '/company': typeof CompanyRoute
  '/contact': typeof ContactRoute
  '/email-link': typeof EmailLinkRoute
  '/email-verify': typeof EmailVerifyRoute
  '/email_settings': typeof Email_settingsRoute
  '/forgot': typeof ForgotRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/happy_birthday': typeof Happy_birthdayRoute
  '/home': typeof HomeRoute
  '/infographic': typeof InfographicRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/payment': typeof PaymentRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reminders': typeof RemindersRoute
  '/reminders-print-view': typeof RemindersPrintViewRoute
  '/safety': typeof SafetyRoute
  '/team': typeof TeamRoute
  '/terms': typeof TermsRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/account/billing': typeof AccountBillingRoute
  '/account/cancel': typeof AccountCancelRoute
  '/admin/ai': typeof AdminAiRoute
  '/admin/api': typeof AdminApiRoute
  '/admin/app-version': typeof AdminAppVersionRoute
  '/admin/avatars': typeof AdminAvatarsRoute
  '/admin/billing-plans': typeof AdminBillingPlansRoute
  '/admin/creators': typeof AdminCreatorsRoute
  '/admin/database-ddl': typeof AdminDatabaseDdlRoute
  '/admin/deliverability': typeof AdminDeliverabilityRoute
  '/admin/email-lookup': typeof AdminEmailLookupRoute
  '/admin/moderation': typeof AdminModerationRouteWithChildren
  '/admin/offline-payments': typeof AdminOfflinePaymentsRoute
  '/admin/popular-names': typeof AdminPopularNamesRoute
  '/admin/query': typeof AdminQueryRoute
  '/admin/reco': typeof AdminRecoRoute
  '/admin/scheduler': typeof AdminSchedulerRoute
  '/admin/schema': typeof AdminSchemaRoute
  '/admin/scripts': typeof AdminScriptsRoute
  '/admin/sentry': typeof AdminSentryRoute
  '/admin/servers': typeof AdminServersRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/suppressions': typeof AdminSuppressionsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/trending': typeof AdminTrendingRoute
  '/admin/verify': typeof AdminVerifyRoute
  '/admin/videos': typeof AdminVideosRoute
  '/admin/websockets': typeof AdminWebsocketsRoute
  '/anniversary/browse': typeof AnniversaryBrowseRoute
  '/anniversary/gift': typeof AnniversaryGiftRoute
  '/bd4/$magic': typeof Bd4MagicRoute
  '/bd5/$magic': typeof Bd5MagicRoute
  '/bd6/$magic': typeof Bd6MagicRoute
  '/bd7/$magic': typeof Bd7MagicRoute
  '/bday/$magic': typeof BdayMagicRoute
  '/billing/return': typeof BillingReturnRoute
  '/birthday/browse': typeof BirthdayBrowseRoute
  '/card/create': typeof CardCreateRoute
  '/cards/$': typeof CardsSplatRoute
  '/cards/browse': typeof CardsBrowseRoute
  '/contacts/import': typeof ContactsImportRoute
  '/dob/$token': typeof DobTokenRoute
  '/gift/sdk-host': typeof GiftSdkHostRoute
  '/holiday/browse': typeof HolidayBrowseRoute
  '/lists/$token': typeof ListsTokenRoute
  '/lists/new': typeof ListsNewRoute
  '/mycards/$type': typeof MycardsTypeRoute
  '/name/$name': typeof NameNameRoute
  '/reminders/add': typeof RemindersAddRoute
  '/reminders/holiday': typeof RemindersHolidayRoute
  '/s/$signToken': typeof SSignTokenRoute
  '/shares/$token': typeof SharesTokenRoute
  '/admin': typeof AdminIndexRoute
  '/cards': typeof CardsIndexRoute
  '/faq': typeof FaqIndexRoute
  '/help': typeof HelpIndexRoute
  '/linked': typeof LinkedIndexRoute
  '/mycards': typeof MycardsIndexRoute
  '/name': typeof NameIndexRoute
  '/support': typeof SupportIndexRoute
  '/admin/backgrounds/$id': typeof AdminBackgroundsIdRoute
  '/admin/cards/$id': typeof AdminCardsIdRoute
  '/admin/categories/$id': typeof AdminCategoriesIdRoute
  '/admin/codes/$codeId': typeof AdminCodesCodeIdRoute
  '/admin/contacts/$id': typeof AdminContactsIdRoute
  '/admin/disputes/$id': typeof AdminDisputesIdRoute
  '/admin/email-audit/$id': typeof AdminEmailAuditIdRoute
  '/admin/email/$id': typeof AdminEmailIdRoute
  '/admin/gift-cards/$giftCardId': typeof AdminGiftCardsGiftCardIdRoute
  '/admin/images/$id': typeof AdminImagesIdRoute
  '/admin/media/$id': typeof AdminMediaIdRoute
  '/admin/moderated-images/$id': typeof AdminModeratedImagesIdRoute
  '/admin/moderation/$reportId': typeof AdminModerationReportIdRoute
  '/admin/newsletters/$issueId': typeof AdminNewslettersIssueIdRoute
  '/admin/occasions/$id': typeof AdminOccasionsIdRoute
  '/admin/push/$id': typeof AdminPushIdRoute
  '/admin/reports/explore': typeof AdminReportsExploreRoute
  '/admin/seed-data/$type': typeof AdminSeedDataTypeRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/birthday/request/howto': typeof BirthdayRequestHowtoRoute
  '/card/read/$slug': typeof CardReadSlugRoute
  '/card/send/create': typeof CardSendCreateRoute
  '/card/view/$cardId': typeof CardViewCardIdRoute
  '/copy/read/$slug': typeof CopyReadSlugRoute
  '/faq/$category/$article': typeof FaqCategoryArticleRoute
  '/help/$section/$article': typeof HelpSectionArticleRoute
  '/linked/requests/$id': typeof LinkedRequestsIdRoute
  '/lists/view/$id': typeof ListsViewIdRoute
  '/reminders/birthday/add': typeof RemindersBirthdayAddRoute
  '/reminders/birthday/more': typeof RemindersBirthdayMoreRoute
  '/reminders/holiday/add': typeof RemindersHolidayAddRoute
  '/support/ticket/$token': typeof SupportTicketTokenRoute
  '/admin/backgrounds': typeof AdminBackgroundsIndexRoute
  '/admin/cards': typeof AdminCardsIndexRoute
  '/admin/categories': typeof AdminCategoriesIndexRoute
  '/admin/codes': typeof AdminCodesIndexRoute
  '/admin/contacts': typeof AdminContactsIndexRoute
  '/admin/countries': typeof AdminCountriesIndexRoute
  '/admin/dispatch-monitor': typeof AdminDispatchMonitorIndexRoute
  '/admin/disputes': typeof AdminDisputesIndexRoute
  '/admin/docs': typeof AdminDocsIndexRoute
  '/admin/email': typeof AdminEmailIndexRoute
  '/admin/gift-cards': typeof AdminGiftCardsIndexRoute
  '/admin/images': typeof AdminImagesIndexRoute
  '/admin/knowledge': typeof AdminKnowledgeIndexRoute
  '/admin/media': typeof AdminMediaIndexRoute
  '/admin/moderated-images': typeof AdminModeratedImagesIndexRoute
  '/admin/newsletters': typeof AdminNewslettersIndexRoute
  '/admin/occasions': typeof AdminOccasionsIndexRoute
  '/admin/push': typeof AdminPushIndexRoute
  '/admin/reports': typeof AdminReportsIndexRoute
  '/admin/seed-data': typeof AdminSeedDataIndexRoute
  '/admin/signing': typeof AdminSigningIndexRoute
  '/admin/sms': typeof AdminSmsIndexRoute
  '/admin/stickers': typeof AdminStickersIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/faq/$category': typeof FaqCategoryIndexRoute
  '/help/$section': typeof HelpSectionIndexRoute
  '/admin/reports/d/$slug': typeof AdminReportsDSlugRoute
  '/card/send/view/$slug': typeof CardSendViewSlugRoute
  '/card/share/view/$slug': typeof CardShareViewSlugRoute
  '/card/sign/edit/$slug': typeof CardSignEditSlugRoute
  '/card/sign/view/$slug': typeof CardSignViewSlugRoute
  '/card/view/$cardId/$slug': typeof CardViewCardIdSlugRoute
  '/reminders/birthday/add/manual': typeof RemindersBirthdayAddManualRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRoute
  '/address_book': typeof Address_bookRoute
  '/auth': typeof AuthRoute
  '/calendar': typeof CalendarRoute
  '/change_password': typeof Change_passwordRoute
  '/company': typeof CompanyRoute
  '/contact': typeof ContactRoute
  '/email-link': typeof EmailLinkRoute
  '/email-verify': typeof EmailVerifyRoute
  '/email_settings': typeof Email_settingsRoute
  '/forgot': typeof ForgotRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/happy_birthday': typeof Happy_birthdayRoute
  '/home': typeof HomeRoute
  '/infographic': typeof InfographicRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/payment': typeof PaymentRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reminders': typeof RemindersRoute
  '/reminders-print-view': typeof RemindersPrintViewRoute
  '/safety': typeof SafetyRoute
  '/team': typeof TeamRoute
  '/terms': typeof TermsRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/account_/billing': typeof AccountBillingRoute
  '/account_/cancel': typeof AccountCancelRoute
  '/admin/ai': typeof AdminAiRoute
  '/admin/api': typeof AdminApiRoute
  '/admin/app-version': typeof AdminAppVersionRoute
  '/admin/avatars': typeof AdminAvatarsRoute
  '/admin/billing-plans': typeof AdminBillingPlansRoute
  '/admin/creators': typeof AdminCreatorsRoute
  '/admin/database-ddl': typeof AdminDatabaseDdlRoute
  '/admin/deliverability': typeof AdminDeliverabilityRoute
  '/admin/email-lookup': typeof AdminEmailLookupRoute
  '/admin/moderation': typeof AdminModerationRouteWithChildren
  '/admin/offline-payments': typeof AdminOfflinePaymentsRoute
  '/admin/popular-names': typeof AdminPopularNamesRoute
  '/admin/query': typeof AdminQueryRoute
  '/admin/reco': typeof AdminRecoRoute
  '/admin/scheduler': typeof AdminSchedulerRoute
  '/admin/schema': typeof AdminSchemaRoute
  '/admin/scripts': typeof AdminScriptsRoute
  '/admin/sentry': typeof AdminSentryRoute
  '/admin/servers': typeof AdminServersRoute
  '/admin/support': typeof AdminSupportRoute
  '/admin/suppressions': typeof AdminSuppressionsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/trending': typeof AdminTrendingRoute
  '/admin/verify': typeof AdminVerifyRoute
  '/admin/videos': typeof AdminVideosRoute
  '/admin/websockets': typeof AdminWebsocketsRoute
  '/anniversary/browse': typeof AnniversaryBrowseRoute
  '/anniversary/gift': typeof AnniversaryGiftRoute
  '/bd4/$magic': typeof Bd4MagicRoute
  '/bd5/$magic': typeof Bd5MagicRoute
  '/bd6/$magic': typeof Bd6MagicRoute
  '/bd7/$magic': typeof Bd7MagicRoute
  '/bday/$magic': typeof BdayMagicRoute
  '/billing/return': typeof BillingReturnRoute
  '/birthday/browse': typeof BirthdayBrowseRoute
  '/card/create': typeof CardCreateRoute
  '/cards/$': typeof CardsSplatRoute
  '/cards/browse': typeof CardsBrowseRoute
  '/contacts/import': typeof ContactsImportRoute
  '/dob/$token': typeof DobTokenRoute
  '/gift/sdk-host': typeof GiftSdkHostRoute
  '/holiday/browse': typeof HolidayBrowseRoute
  '/lists/$token': typeof ListsTokenRoute
  '/lists/new': typeof ListsNewRoute
  '/mycards/$type': typeof MycardsTypeRoute
  '/name/$name': typeof NameNameRoute
  '/reminders_/add': typeof RemindersAddRoute
  '/reminders_/holiday': typeof RemindersHolidayRoute
  '/s/$signToken': typeof SSignTokenRoute
  '/shares/$token': typeof SharesTokenRoute
  '/admin/': typeof AdminIndexRoute
  '/cards/': typeof CardsIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/help/': typeof HelpIndexRoute
  '/linked/': typeof LinkedIndexRoute
  '/mycards/': typeof MycardsIndexRoute
  '/name/': typeof NameIndexRoute
  '/support/': typeof SupportIndexRoute
  '/admin/backgrounds/$id': typeof AdminBackgroundsIdRoute
  '/admin/cards/$id': typeof AdminCardsIdRoute
  '/admin/categories/$id': typeof AdminCategoriesIdRoute
  '/admin/codes/$codeId': typeof AdminCodesCodeIdRoute
  '/admin/contacts/$id': typeof AdminContactsIdRoute
  '/admin/disputes/$id': typeof AdminDisputesIdRoute
  '/admin/email-audit/$id': typeof AdminEmailAuditIdRoute
  '/admin/email/$id': typeof AdminEmailIdRoute
  '/admin/gift-cards/$giftCardId': typeof AdminGiftCardsGiftCardIdRoute
  '/admin/images/$id': typeof AdminImagesIdRoute
  '/admin/media/$id': typeof AdminMediaIdRoute
  '/admin/moderated-images/$id': typeof AdminModeratedImagesIdRoute
  '/admin/moderation/$reportId': typeof AdminModerationReportIdRoute
  '/admin/newsletters/$issueId': typeof AdminNewslettersIssueIdRoute
  '/admin/occasions/$id': typeof AdminOccasionsIdRoute
  '/admin/push/$id': typeof AdminPushIdRoute
  '/admin/reports/explore': typeof AdminReportsExploreRoute
  '/admin/seed-data/$type': typeof AdminSeedDataTypeRoute
  '/admin/users/$id': typeof AdminUsersIdRoute
  '/birthday_/request_/howto': typeof BirthdayRequestHowtoRoute
  '/card/read/$slug': typeof CardReadSlugRoute
  '/card/send/create': typeof CardSendCreateRoute
  '/card/view/$cardId': typeof CardViewCardIdRoute
  '/copy/read/$slug': typeof CopyReadSlugRoute
  '/faq/$category/$article': typeof FaqCategoryArticleRoute
  '/help/$section/$article': typeof HelpSectionArticleRoute
  '/linked/requests/$id': typeof LinkedRequestsIdRoute
  '/lists/view/$id': typeof ListsViewIdRoute
  '/reminders_/birthday_/add': typeof RemindersBirthdayAddRoute
  '/reminders_/birthday_/more': typeof RemindersBirthdayMoreRoute
  '/reminders_/holiday_/add': typeof RemindersHolidayAddRoute
  '/support/ticket/$token': typeof SupportTicketTokenRoute
  '/admin/backgrounds/': typeof AdminBackgroundsIndexRoute
  '/admin/cards/': typeof AdminCardsIndexRoute
  '/admin/categories/': typeof AdminCategoriesIndexRoute
  '/admin/codes/': typeof AdminCodesIndexRoute
  '/admin/contacts/': typeof AdminContactsIndexRoute
  '/admin/countries/': typeof AdminCountriesIndexRoute
  '/admin/dispatch-monitor/': typeof AdminDispatchMonitorIndexRoute
  '/admin/disputes/': typeof AdminDisputesIndexRoute
  '/admin/docs/': typeof AdminDocsIndexRoute
  '/admin/email/': typeof AdminEmailIndexRoute
  '/admin/gift-cards/': typeof AdminGiftCardsIndexRoute
  '/admin/images/': typeof AdminImagesIndexRoute
  '/admin/knowledge/': typeof AdminKnowledgeIndexRoute
  '/admin/media/': typeof AdminMediaIndexRoute
  '/admin/moderated-images/': typeof AdminModeratedImagesIndexRoute
  '/admin/newsletters/': typeof AdminNewslettersIndexRoute
  '/admin/occasions/': typeof AdminOccasionsIndexRoute
  '/admin/push/': typeof AdminPushIndexRoute
  '/admin/reports/': typeof AdminReportsIndexRoute
  '/admin/seed-data/': typeof AdminSeedDataIndexRoute
  '/admin/signing/': typeof AdminSigningIndexRoute
  '/admin/sms/': typeof AdminSmsIndexRoute
  '/admin/stickers/': typeof AdminStickersIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/faq/$category/': typeof FaqCategoryIndexRoute
  '/help/$section/': typeof HelpSectionIndexRoute
  '/admin/reports/d/$slug': typeof AdminReportsDSlugRoute
  '/card/send/view/$slug': typeof CardSendViewSlugRoute
  '/card/share/view/$slug': typeof CardShareViewSlugRoute
  '/card/sign/edit/$slug': typeof CardSignEditSlugRoute
  '/card/sign/view/$slug': typeof CardSignViewSlugRoute
  '/card/view/$cardId_/$slug': typeof CardViewCardIdSlugRoute
  '/reminders_/birthday_/add_/manual': typeof RemindersBirthdayAddManualRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/address_book'
    | '/auth'
    | '/calendar'
    | '/change_password'
    | '/company'
    | '/contact'
    | '/email-link'
    | '/email-verify'
    | '/email_settings'
    | '/forgot'
    | '/forgot-password'
    | '/happy_birthday'
    | '/home'
    | '/infographic'
    | '/login'
    | '/notifications'
    | '/payment'
    | '/privacy'
    | '/register'
    | '/reminders'
    | '/reminders-print-view'
    | '/safety'
    | '/team'
    | '/terms'
    | '/unsubscribe'
    | '/verify'
    | '/account/billing'
    | '/account/cancel'
    | '/admin/ai'
    | '/admin/api'
    | '/admin/app-version'
    | '/admin/avatars'
    | '/admin/billing-plans'
    | '/admin/creators'
    | '/admin/database-ddl'
    | '/admin/deliverability'
    | '/admin/email-lookup'
    | '/admin/moderation'
    | '/admin/offline-payments'
    | '/admin/popular-names'
    | '/admin/query'
    | '/admin/reco'
    | '/admin/scheduler'
    | '/admin/schema'
    | '/admin/scripts'
    | '/admin/sentry'
    | '/admin/servers'
    | '/admin/support'
    | '/admin/suppressions'
    | '/admin/tags'
    | '/admin/trending'
    | '/admin/verify'
    | '/admin/videos'
    | '/admin/websockets'
    | '/anniversary/browse'
    | '/anniversary/gift'
    | '/bd4/$magic'
    | '/bd5/$magic'
    | '/bd6/$magic'
    | '/bd7/$magic'
    | '/bday/$magic'
    | '/billing/return'
    | '/birthday/browse'
    | '/card/create'
    | '/cards/$'
    | '/cards/browse'
    | '/contacts/import'
    | '/dob/$token'
    | '/gift/sdk-host'
    | '/holiday/browse'
    | '/lists/$token'
    | '/lists/new'
    | '/mycards/$type'
    | '/name/$name'
    | '/reminders/add'
    | '/reminders/holiday'
    | '/s/$signToken'
    | '/shares/$token'
    | '/admin/'
    | '/cards/'
    | '/faq/'
    | '/help/'
    | '/linked/'
    | '/mycards/'
    | '/name/'
    | '/support/'
    | '/admin/backgrounds/$id'
    | '/admin/cards/$id'
    | '/admin/categories/$id'
    | '/admin/codes/$codeId'
    | '/admin/contacts/$id'
    | '/admin/disputes/$id'
    | '/admin/email-audit/$id'
    | '/admin/email/$id'
    | '/admin/gift-cards/$giftCardId'
    | '/admin/images/$id'
    | '/admin/media/$id'
    | '/admin/moderated-images/$id'
    | '/admin/moderation/$reportId'
    | '/admin/newsletters/$issueId'
    | '/admin/occasions/$id'
    | '/admin/push/$id'
    | '/admin/reports/explore'
    | '/admin/seed-data/$type'
    | '/admin/users/$id'
    | '/birthday/request/howto'
    | '/card/read/$slug'
    | '/card/send/create'
    | '/card/view/$cardId'
    | '/copy/read/$slug'
    | '/faq/$category/$article'
    | '/help/$section/$article'
    | '/linked/requests/$id'
    | '/lists/view/$id'
    | '/reminders/birthday/add'
    | '/reminders/birthday/more'
    | '/reminders/holiday/add'
    | '/support/ticket/$token'
    | '/admin/backgrounds/'
    | '/admin/cards/'
    | '/admin/categories/'
    | '/admin/codes/'
    | '/admin/contacts/'
    | '/admin/countries/'
    | '/admin/dispatch-monitor/'
    | '/admin/disputes/'
    | '/admin/docs/'
    | '/admin/email/'
    | '/admin/gift-cards/'
    | '/admin/images/'
    | '/admin/knowledge/'
    | '/admin/media/'
    | '/admin/moderated-images/'
    | '/admin/newsletters/'
    | '/admin/occasions/'
    | '/admin/push/'
    | '/admin/reports/'
    | '/admin/seed-data/'
    | '/admin/signing/'
    | '/admin/sms/'
    | '/admin/stickers/'
    | '/admin/users/'
    | '/faq/$category/'
    | '/help/$section/'
    | '/admin/reports/d/$slug'
    | '/card/send/view/$slug'
    | '/card/share/view/$slug'
    | '/card/sign/edit/$slug'
    | '/card/sign/view/$slug'
    | '/card/view/$cardId/$slug'
    | '/reminders/birthday/add/manual'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account'
    | '/address_book'
    | '/auth'
    | '/calendar'
    | '/change_password'
    | '/company'
    | '/contact'
    | '/email-link'
    | '/email-verify'
    | '/email_settings'
    | '/forgot'
    | '/forgot-password'
    | '/happy_birthday'
    | '/home'
    | '/infographic'
    | '/login'
    | '/notifications'
    | '/payment'
    | '/privacy'
    | '/register'
    | '/reminders'
    | '/reminders-print-view'
    | '/safety'
    | '/team'
    | '/terms'
    | '/unsubscribe'
    | '/verify'
    | '/account/billing'
    | '/account/cancel'
    | '/admin/ai'
    | '/admin/api'
    | '/admin/app-version'
    | '/admin/avatars'
    | '/admin/billing-plans'
    | '/admin/creators'
    | '/admin/database-ddl'
    | '/admin/deliverability'
    | '/admin/email-lookup'
    | '/admin/moderation'
    | '/admin/offline-payments'
    | '/admin/popular-names'
    | '/admin/query'
    | '/admin/reco'
    | '/admin/scheduler'
    | '/admin/schema'
    | '/admin/scripts'
    | '/admin/sentry'
    | '/admin/servers'
    | '/admin/support'
    | '/admin/suppressions'
    | '/admin/tags'
    | '/admin/trending'
    | '/admin/verify'
    | '/admin/videos'
    | '/admin/websockets'
    | '/anniversary/browse'
    | '/anniversary/gift'
    | '/bd4/$magic'
    | '/bd5/$magic'
    | '/bd6/$magic'
    | '/bd7/$magic'
    | '/bday/$magic'
    | '/billing/return'
    | '/birthday/browse'
    | '/card/create'
    | '/cards/$'
    | '/cards/browse'
    | '/contacts/import'
    | '/dob/$token'
    | '/gift/sdk-host'
    | '/holiday/browse'
    | '/lists/$token'
    | '/lists/new'
    | '/mycards/$type'
    | '/name/$name'
    | '/reminders/add'
    | '/reminders/holiday'
    | '/s/$signToken'
    | '/shares/$token'
    | '/admin'
    | '/cards'
    | '/faq'
    | '/help'
    | '/linked'
    | '/mycards'
    | '/name'
    | '/support'
    | '/admin/backgrounds/$id'
    | '/admin/cards/$id'
    | '/admin/categories/$id'
    | '/admin/codes/$codeId'
    | '/admin/contacts/$id'
    | '/admin/disputes/$id'
    | '/admin/email-audit/$id'
    | '/admin/email/$id'
    | '/admin/gift-cards/$giftCardId'
    | '/admin/images/$id'
    | '/admin/media/$id'
    | '/admin/moderated-images/$id'
    | '/admin/moderation/$reportId'
    | '/admin/newsletters/$issueId'
    | '/admin/occasions/$id'
    | '/admin/push/$id'
    | '/admin/reports/explore'
    | '/admin/seed-data/$type'
    | '/admin/users/$id'
    | '/birthday/request/howto'
    | '/card/read/$slug'
    | '/card/send/create'
    | '/card/view/$cardId'
    | '/copy/read/$slug'
    | '/faq/$category/$article'
    | '/help/$section/$article'
    | '/linked/requests/$id'
    | '/lists/view/$id'
    | '/reminders/birthday/add'
    | '/reminders/birthday/more'
    | '/reminders/holiday/add'
    | '/support/ticket/$token'
    | '/admin/backgrounds'
    | '/admin/cards'
    | '/admin/categories'
    | '/admin/codes'
    | '/admin/contacts'
    | '/admin/countries'
    | '/admin/dispatch-monitor'
    | '/admin/disputes'
    | '/admin/docs'
    | '/admin/email'
    | '/admin/gift-cards'
    | '/admin/images'
    | '/admin/knowledge'
    | '/admin/media'
    | '/admin/moderated-images'
    | '/admin/newsletters'
    | '/admin/occasions'
    | '/admin/push'
    | '/admin/reports'
    | '/admin/seed-data'
    | '/admin/signing'
    | '/admin/sms'
    | '/admin/stickers'
    | '/admin/users'
    | '/faq/$category'
    | '/help/$section'
    | '/admin/reports/d/$slug'
    | '/card/send/view/$slug'
    | '/card/share/view/$slug'
    | '/card/sign/edit/$slug'
    | '/card/sign/view/$slug'
    | '/card/view/$cardId/$slug'
    | '/reminders/birthday/add/manual'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/address_book'
    | '/auth'
    | '/calendar'
    | '/change_password'
    | '/company'
    | '/contact'
    | '/email-link'
    | '/email-verify'
    | '/email_settings'
    | '/forgot'
    | '/forgot-password'
    | '/happy_birthday'
    | '/home'
    | '/infographic'
    | '/login'
    | '/notifications'
    | '/payment'
    | '/privacy'
    | '/register'
    | '/reminders'
    | '/reminders-print-view'
    | '/safety'
    | '/team'
    | '/terms'
    | '/unsubscribe'
    | '/verify'
    | '/account_/billing'
    | '/account_/cancel'
    | '/admin/ai'
    | '/admin/api'
    | '/admin/app-version'
    | '/admin/avatars'
    | '/admin/billing-plans'
    | '/admin/creators'
    | '/admin/database-ddl'
    | '/admin/deliverability'
    | '/admin/email-lookup'
    | '/admin/moderation'
    | '/admin/offline-payments'
    | '/admin/popular-names'
    | '/admin/query'
    | '/admin/reco'
    | '/admin/scheduler'
    | '/admin/schema'
    | '/admin/scripts'
    | '/admin/sentry'
    | '/admin/servers'
    | '/admin/support'
    | '/admin/suppressions'
    | '/admin/tags'
    | '/admin/trending'
    | '/admin/verify'
    | '/admin/videos'
    | '/admin/websockets'
    | '/anniversary/browse'
    | '/anniversary/gift'
    | '/bd4/$magic'
    | '/bd5/$magic'
    | '/bd6/$magic'
    | '/bd7/$magic'
    | '/bday/$magic'
    | '/billing/return'
    | '/birthday/browse'
    | '/card/create'
    | '/cards/$'
    | '/cards/browse'
    | '/contacts/import'
    | '/dob/$token'
    | '/gift/sdk-host'
    | '/holiday/browse'
    | '/lists/$token'
    | '/lists/new'
    | '/mycards/$type'
    | '/name/$name'
    | '/reminders_/add'
    | '/reminders_/holiday'
    | '/s/$signToken'
    | '/shares/$token'
    | '/admin/'
    | '/cards/'
    | '/faq/'
    | '/help/'
    | '/linked/'
    | '/mycards/'
    | '/name/'
    | '/support/'
    | '/admin/backgrounds/$id'
    | '/admin/cards/$id'
    | '/admin/categories/$id'
    | '/admin/codes/$codeId'
    | '/admin/contacts/$id'
    | '/admin/disputes/$id'
    | '/admin/email-audit/$id'
    | '/admin/email/$id'
    | '/admin/gift-cards/$giftCardId'
    | '/admin/images/$id'
    | '/admin/media/$id'
    | '/admin/moderated-images/$id'
    | '/admin/moderation/$reportId'
    | '/admin/newsletters/$issueId'
    | '/admin/occasions/$id'
    | '/admin/push/$id'
    | '/admin/reports/explore'
    | '/admin/seed-data/$type'
    | '/admin/users/$id'
    | '/birthday_/request_/howto'
    | '/card/read/$slug'
    | '/card/send/create'
    | '/card/view/$cardId'
    | '/copy/read/$slug'
    | '/faq/$category/$article'
    | '/help/$section/$article'
    | '/linked/requests/$id'
    | '/lists/view/$id'
    | '/reminders_/birthday_/add'
    | '/reminders_/birthday_/more'
    | '/reminders_/holiday_/add'
    | '/support/ticket/$token'
    | '/admin/backgrounds/'
    | '/admin/cards/'
    | '/admin/categories/'
    | '/admin/codes/'
    | '/admin/contacts/'
    | '/admin/countries/'
    | '/admin/dispatch-monitor/'
    | '/admin/disputes/'
    | '/admin/docs/'
    | '/admin/email/'
    | '/admin/gift-cards/'
    | '/admin/images/'
    | '/admin/knowledge/'
    | '/admin/media/'
    | '/admin/moderated-images/'
    | '/admin/newsletters/'
    | '/admin/occasions/'
    | '/admin/push/'
    | '/admin/reports/'
    | '/admin/seed-data/'
    | '/admin/signing/'
    | '/admin/sms/'
    | '/admin/stickers/'
    | '/admin/users/'
    | '/faq/$category/'
    | '/help/$section/'
    | '/admin/reports/d/$slug'
    | '/card/send/view/$slug'
    | '/card/share/view/$slug'
    | '/card/sign/edit/$slug'
    | '/card/sign/view/$slug'
    | '/card/view/$cardId_/$slug'
    | '/reminders_/birthday_/add_/manual'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRoute
  Address_bookRoute: typeof Address_bookRoute
  AuthRoute: typeof AuthRoute
  CalendarRoute: typeof CalendarRoute
  Change_passwordRoute: typeof Change_passwordRoute
  CompanyRoute: typeof CompanyRoute
  ContactRoute: typeof ContactRoute
  EmailLinkRoute: typeof EmailLinkRoute
  EmailVerifyRoute: typeof EmailVerifyRoute
  Email_settingsRoute: typeof Email_settingsRoute
  ForgotRoute: typeof ForgotRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  Happy_birthdayRoute: typeof Happy_birthdayRoute
  HomeRoute: typeof HomeRoute
  InfographicRoute: typeof InfographicRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  PaymentRoute: typeof PaymentRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  RemindersRoute: typeof RemindersRoute
  RemindersPrintViewRoute: typeof RemindersPrintViewRoute
  SafetyRoute: typeof SafetyRoute
  TeamRoute: typeof TeamRoute
  TermsRoute: typeof TermsRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  VerifyRoute: typeof VerifyRoute
  AccountBillingRoute: typeof AccountBillingRoute
  AccountCancelRoute: typeof AccountCancelRoute
  AdminAiRoute: typeof AdminAiRoute
  AdminApiRoute: typeof AdminApiRoute
  AdminAppVersionRoute: typeof AdminAppVersionRoute
  AdminAvatarsRoute: typeof AdminAvatarsRoute
  AdminBillingPlansRoute: typeof AdminBillingPlansRoute
  AdminCreatorsRoute: typeof AdminCreatorsRoute
  AdminDatabaseDdlRoute: typeof AdminDatabaseDdlRoute
  AdminDeliverabilityRoute: typeof AdminDeliverabilityRoute
  AdminEmailLookupRoute: typeof AdminEmailLookupRoute
  AdminModerationRoute: typeof AdminModerationRouteWithChildren
  AdminOfflinePaymentsRoute: typeof AdminOfflinePaymentsRoute
  AdminPopularNamesRoute: typeof AdminPopularNamesRoute
  AdminQueryRoute: typeof AdminQueryRoute
  AdminRecoRoute: typeof AdminRecoRoute
  AdminSchedulerRoute: typeof AdminSchedulerRoute
  AdminSchemaRoute: typeof AdminSchemaRoute
  AdminScriptsRoute: typeof AdminScriptsRoute
  AdminSentryRoute: typeof AdminSentryRoute
  AdminServersRoute: typeof AdminServersRoute
  AdminSupportRoute: typeof AdminSupportRoute
  AdminSuppressionsRoute: typeof AdminSuppressionsRoute
  AdminTagsRoute: typeof AdminTagsRoute
  AdminTrendingRoute: typeof AdminTrendingRoute
  AdminVerifyRoute: typeof AdminVerifyRoute
  AdminVideosRoute: typeof AdminVideosRoute
  AdminWebsocketsRoute: typeof AdminWebsocketsRoute
  AnniversaryBrowseRoute: typeof AnniversaryBrowseRoute
  AnniversaryGiftRoute: typeof AnniversaryGiftRoute
  Bd4MagicRoute: typeof Bd4MagicRoute
  Bd5MagicRoute: typeof Bd5MagicRoute
  Bd6MagicRoute: typeof Bd6MagicRoute
  Bd7MagicRoute: typeof Bd7MagicRoute
  BdayMagicRoute: typeof BdayMagicRoute
  BillingReturnRoute: typeof BillingReturnRoute
  BirthdayBrowseRoute: typeof BirthdayBrowseRoute
  CardCreateRoute: typeof CardCreateRoute
  CardsSplatRoute: typeof CardsSplatRoute
  CardsBrowseRoute: typeof CardsBrowseRoute
  ContactsImportRoute: typeof ContactsImportRoute
  DobTokenRoute: typeof DobTokenRoute
  GiftSdkHostRoute: typeof GiftSdkHostRoute
  HolidayBrowseRoute: typeof HolidayBrowseRoute
  ListsTokenRoute: typeof ListsTokenRoute
  ListsNewRoute: typeof ListsNewRoute
  MycardsTypeRoute: typeof MycardsTypeRoute
  NameNameRoute: typeof NameNameRoute
  RemindersAddRoute: typeof RemindersAddRoute
  RemindersHolidayRoute: typeof RemindersHolidayRoute
  SSignTokenRoute: typeof SSignTokenRoute
  SharesTokenRoute: typeof SharesTokenRoute
  AdminIndexRoute: typeof AdminIndexRoute
  CardsIndexRoute: typeof CardsIndexRoute
  FaqIndexRoute: typeof FaqIndexRoute
  HelpIndexRoute: typeof HelpIndexRoute
  LinkedIndexRoute: typeof LinkedIndexRoute
  MycardsIndexRoute: typeof MycardsIndexRoute
  NameIndexRoute: typeof NameIndexRoute
  SupportIndexRoute: typeof SupportIndexRoute
  AdminBackgroundsIdRoute: typeof AdminBackgroundsIdRoute
  AdminCardsIdRoute: typeof AdminCardsIdRoute
  AdminCategoriesIdRoute: typeof AdminCategoriesIdRoute
  AdminCodesCodeIdRoute: typeof AdminCodesCodeIdRoute
  AdminContactsIdRoute: typeof AdminContactsIdRoute
  AdminDisputesIdRoute: typeof AdminDisputesIdRoute
  AdminEmailAuditIdRoute: typeof AdminEmailAuditIdRoute
  AdminEmailIdRoute: typeof AdminEmailIdRoute
  AdminGiftCardsGiftCardIdRoute: typeof AdminGiftCardsGiftCardIdRoute
  AdminImagesIdRoute: typeof AdminImagesIdRoute
  AdminMediaIdRoute: typeof AdminMediaIdRoute
  AdminModeratedImagesIdRoute: typeof AdminModeratedImagesIdRoute
  AdminNewslettersIssueIdRoute: typeof AdminNewslettersIssueIdRoute
  AdminOccasionsIdRoute: typeof AdminOccasionsIdRoute
  AdminPushIdRoute: typeof AdminPushIdRoute
  AdminReportsExploreRoute: typeof AdminReportsExploreRoute
  AdminSeedDataTypeRoute: typeof AdminSeedDataTypeRoute
  AdminUsersIdRoute: typeof AdminUsersIdRoute
  BirthdayRequestHowtoRoute: typeof BirthdayRequestHowtoRoute
  CardReadSlugRoute: typeof CardReadSlugRoute
  CardSendCreateRoute: typeof CardSendCreateRoute
  CardViewCardIdRoute: typeof CardViewCardIdRoute
  CopyReadSlugRoute: typeof CopyReadSlugRoute
  FaqCategoryArticleRoute: typeof FaqCategoryArticleRoute
  HelpSectionArticleRoute: typeof HelpSectionArticleRoute
  LinkedRequestsIdRoute: typeof LinkedRequestsIdRoute
  ListsViewIdRoute: typeof ListsViewIdRoute
  RemindersBirthdayAddRoute: typeof RemindersBirthdayAddRoute
  RemindersBirthdayMoreRoute: typeof RemindersBirthdayMoreRoute
  RemindersHolidayAddRoute: typeof RemindersHolidayAddRoute
  SupportTicketTokenRoute: typeof SupportTicketTokenRoute
  AdminBackgroundsIndexRoute: typeof AdminBackgroundsIndexRoute
  AdminCardsIndexRoute: typeof AdminCardsIndexRoute
  AdminCategoriesIndexRoute: typeof AdminCategoriesIndexRoute
  AdminCodesIndexRoute: typeof AdminCodesIndexRoute
  AdminContactsIndexRoute: typeof AdminContactsIndexRoute
  AdminCountriesIndexRoute: typeof AdminCountriesIndexRoute
  AdminDispatchMonitorIndexRoute: typeof AdminDispatchMonitorIndexRoute
  AdminDisputesIndexRoute: typeof AdminDisputesIndexRoute
  AdminDocsIndexRoute: typeof AdminDocsIndexRoute
  AdminEmailIndexRoute: typeof AdminEmailIndexRoute
  AdminGiftCardsIndexRoute: typeof AdminGiftCardsIndexRoute
  AdminImagesIndexRoute: typeof AdminImagesIndexRoute
  AdminKnowledgeIndexRoute: typeof AdminKnowledgeIndexRoute
  AdminMediaIndexRoute: typeof AdminMediaIndexRoute
  AdminModeratedImagesIndexRoute: typeof AdminModeratedImagesIndexRoute
  AdminNewslettersIndexRoute: typeof AdminNewslettersIndexRoute
  AdminOccasionsIndexRoute: typeof AdminOccasionsIndexRoute
  AdminPushIndexRoute: typeof AdminPushIndexRoute
  AdminReportsIndexRoute: typeof AdminReportsIndexRoute
  AdminSeedDataIndexRoute: typeof AdminSeedDataIndexRoute
  AdminSigningIndexRoute: typeof AdminSigningIndexRoute
  AdminSmsIndexRoute: typeof AdminSmsIndexRoute
  AdminStickersIndexRoute: typeof AdminStickersIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  FaqCategoryIndexRoute: typeof FaqCategoryIndexRoute
  HelpSectionIndexRoute: typeof HelpSectionIndexRoute
  AdminReportsDSlugRoute: typeof AdminReportsDSlugRoute
  CardSendViewSlugRoute: typeof CardSendViewSlugRoute
  CardShareViewSlugRoute: typeof CardShareViewSlugRoute
  CardSignEditSlugRoute: typeof CardSignEditSlugRoute
  CardSignViewSlugRoute: typeof CardSignViewSlugRoute
  CardViewCardIdSlugRoute: typeof CardViewCardIdSlugRoute
  RemindersBirthdayAddManualRoute: typeof RemindersBirthdayAddManualRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/safety': {
      id: '/safety'
      path: '/safety'
      fullPath: '/safety'
      preLoaderRoute: typeof SafetyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders-print-view': {
      id: '/reminders-print-view'
      path: '/reminders-print-view'
      fullPath: '/reminders-print-view'
      preLoaderRoute: typeof RemindersPrintViewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders': {
      id: '/reminders'
      path: '/reminders'
      fullPath: '/reminders'
      preLoaderRoute: typeof RemindersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment': {
      id: '/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof PaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/infographic': {
      id: '/infographic'
      path: '/infographic'
      fullPath: '/infographic'
      preLoaderRoute: typeof InfographicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/happy_birthday': {
      id: '/happy_birthday'
      path: '/happy_birthday'
      fullPath: '/happy_birthday'
      preLoaderRoute: typeof Happy_birthdayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot': {
      id: '/forgot'
      path: '/forgot'
      fullPath: '/forgot'
      preLoaderRoute: typeof ForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email_settings': {
      id: '/email_settings'
      path: '/email_settings'
      fullPath: '/email_settings'
      preLoaderRoute: typeof Email_settingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-verify': {
      id: '/email-verify'
      path: '/email-verify'
      fullPath: '/email-verify'
      preLoaderRoute: typeof EmailVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/email-link': {
      id: '/email-link'
      path: '/email-link'
      fullPath: '/email-link'
      preLoaderRoute: typeof EmailLinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/company': {
      id: '/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof CompanyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change_password': {
      id: '/change_password'
      path: '/change_password'
      fullPath: '/change_password'
      preLoaderRoute: typeof Change_passwordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/address_book': {
      id: '/address_book'
      path: '/address_book'
      fullPath: '/address_book'
      preLoaderRoute: typeof Address_bookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/support'
      fullPath: '/support/'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/name/': {
      id: '/name/'
      path: '/name'
      fullPath: '/name/'
      preLoaderRoute: typeof NameIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mycards/': {
      id: '/mycards/'
      path: '/mycards'
      fullPath: '/mycards/'
      preLoaderRoute: typeof MycardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/linked/': {
      id: '/linked/'
      path: '/linked'
      fullPath: '/linked/'
      preLoaderRoute: typeof LinkedIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/': {
      id: '/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof HelpIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/': {
      id: '/faq/'
      path: '/faq'
      fullPath: '/faq/'
      preLoaderRoute: typeof FaqIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards/': {
      id: '/cards/'
      path: '/cards'
      fullPath: '/cards/'
      preLoaderRoute: typeof CardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shares/$token': {
      id: '/shares/$token'
      path: '/shares/$token'
      fullPath: '/shares/$token'
      preLoaderRoute: typeof SharesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$signToken': {
      id: '/s/$signToken'
      path: '/s/$signToken'
      fullPath: '/s/$signToken'
      preLoaderRoute: typeof SSignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders_/holiday': {
      id: '/reminders_/holiday'
      path: '/reminders/holiday'
      fullPath: '/reminders/holiday'
      preLoaderRoute: typeof RemindersHolidayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders_/add': {
      id: '/reminders_/add'
      path: '/reminders/add'
      fullPath: '/reminders/add'
      preLoaderRoute: typeof RemindersAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/name/$name': {
      id: '/name/$name'
      path: '/name/$name'
      fullPath: '/name/$name'
      preLoaderRoute: typeof NameNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mycards/$type': {
      id: '/mycards/$type'
      path: '/mycards/$type'
      fullPath: '/mycards/$type'
      preLoaderRoute: typeof MycardsTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/new': {
      id: '/lists/new'
      path: '/lists/new'
      fullPath: '/lists/new'
      preLoaderRoute: typeof ListsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/$token': {
      id: '/lists/$token'
      path: '/lists/$token'
      fullPath: '/lists/$token'
      preLoaderRoute: typeof ListsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/holiday/browse': {
      id: '/holiday/browse'
      path: '/holiday/browse'
      fullPath: '/holiday/browse'
      preLoaderRoute: typeof HolidayBrowseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gift/sdk-host': {
      id: '/gift/sdk-host'
      path: '/gift/sdk-host'
      fullPath: '/gift/sdk-host'
      preLoaderRoute: typeof GiftSdkHostRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dob/$token': {
      id: '/dob/$token'
      path: '/dob/$token'
      fullPath: '/dob/$token'
      preLoaderRoute: typeof DobTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/import': {
      id: '/contacts/import'
      path: '/contacts/import'
      fullPath: '/contacts/import'
      preLoaderRoute: typeof ContactsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards/browse': {
      id: '/cards/browse'
      path: '/cards/browse'
      fullPath: '/cards/browse'
      preLoaderRoute: typeof CardsBrowseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards/$': {
      id: '/cards/$'
      path: '/cards/$'
      fullPath: '/cards/$'
      preLoaderRoute: typeof CardsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/create': {
      id: '/card/create'
      path: '/card/create'
      fullPath: '/card/create'
      preLoaderRoute: typeof CardCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/birthday/browse': {
      id: '/birthday/browse'
      path: '/birthday/browse'
      fullPath: '/birthday/browse'
      preLoaderRoute: typeof BirthdayBrowseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing/return': {
      id: '/billing/return'
      path: '/billing/return'
      fullPath: '/billing/return'
      preLoaderRoute: typeof BillingReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bday/$magic': {
      id: '/bday/$magic'
      path: '/bday/$magic'
      fullPath: '/bday/$magic'
      preLoaderRoute: typeof BdayMagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bd7/$magic': {
      id: '/bd7/$magic'
      path: '/bd7/$magic'
      fullPath: '/bd7/$magic'
      preLoaderRoute: typeof Bd7MagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bd6/$magic': {
      id: '/bd6/$magic'
      path: '/bd6/$magic'
      fullPath: '/bd6/$magic'
      preLoaderRoute: typeof Bd6MagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bd5/$magic': {
      id: '/bd5/$magic'
      path: '/bd5/$magic'
      fullPath: '/bd5/$magic'
      preLoaderRoute: typeof Bd5MagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bd4/$magic': {
      id: '/bd4/$magic'
      path: '/bd4/$magic'
      fullPath: '/bd4/$magic'
      preLoaderRoute: typeof Bd4MagicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anniversary/gift': {
      id: '/anniversary/gift'
      path: '/anniversary/gift'
      fullPath: '/anniversary/gift'
      preLoaderRoute: typeof AnniversaryGiftRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anniversary/browse': {
      id: '/anniversary/browse'
      path: '/anniversary/browse'
      fullPath: '/anniversary/browse'
      preLoaderRoute: typeof AnniversaryBrowseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/websockets': {
      id: '/admin/websockets'
      path: '/admin/websockets'
      fullPath: '/admin/websockets'
      preLoaderRoute: typeof AdminWebsocketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/videos': {
      id: '/admin/videos'
      path: '/admin/videos'
      fullPath: '/admin/videos'
      preLoaderRoute: typeof AdminVideosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/verify': {
      id: '/admin/verify'
      path: '/admin/verify'
      fullPath: '/admin/verify'
      preLoaderRoute: typeof AdminVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/trending': {
      id: '/admin/trending'
      path: '/admin/trending'
      fullPath: '/admin/trending'
      preLoaderRoute: typeof AdminTrendingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tags': {
      id: '/admin/tags'
      path: '/admin/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AdminTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/suppressions': {
      id: '/admin/suppressions'
      path: '/admin/suppressions'
      fullPath: '/admin/suppressions'
      preLoaderRoute: typeof AdminSuppressionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/support': {
      id: '/admin/support'
      path: '/admin/support'
      fullPath: '/admin/support'
      preLoaderRoute: typeof AdminSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/servers': {
      id: '/admin/servers'
      path: '/admin/servers'
      fullPath: '/admin/servers'
      preLoaderRoute: typeof AdminServersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sentry': {
      id: '/admin/sentry'
      path: '/admin/sentry'
      fullPath: '/admin/sentry'
      preLoaderRoute: typeof AdminSentryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/scripts': {
      id: '/admin/scripts'
      path: '/admin/scripts'
      fullPath: '/admin/scripts'
      preLoaderRoute: typeof AdminScriptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/schema': {
      id: '/admin/schema'
      path: '/admin/schema'
      fullPath: '/admin/schema'
      preLoaderRoute: typeof AdminSchemaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/scheduler': {
      id: '/admin/scheduler'
      path: '/admin/scheduler'
      fullPath: '/admin/scheduler'
      preLoaderRoute: typeof AdminSchedulerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reco': {
      id: '/admin/reco'
      path: '/admin/reco'
      fullPath: '/admin/reco'
      preLoaderRoute: typeof AdminRecoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/query': {
      id: '/admin/query'
      path: '/admin/query'
      fullPath: '/admin/query'
      preLoaderRoute: typeof AdminQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/popular-names': {
      id: '/admin/popular-names'
      path: '/admin/popular-names'
      fullPath: '/admin/popular-names'
      preLoaderRoute: typeof AdminPopularNamesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/offline-payments': {
      id: '/admin/offline-payments'
      path: '/admin/offline-payments'
      fullPath: '/admin/offline-payments'
      preLoaderRoute: typeof AdminOfflinePaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/moderation': {
      id: '/admin/moderation'
      path: '/admin/moderation'
      fullPath: '/admin/moderation'
      preLoaderRoute: typeof AdminModerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email-lookup': {
      id: '/admin/email-lookup'
      path: '/admin/email-lookup'
      fullPath: '/admin/email-lookup'
      preLoaderRoute: typeof AdminEmailLookupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/deliverability': {
      id: '/admin/deliverability'
      path: '/admin/deliverability'
      fullPath: '/admin/deliverability'
      preLoaderRoute: typeof AdminDeliverabilityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/database-ddl': {
      id: '/admin/database-ddl'
      path: '/admin/database-ddl'
      fullPath: '/admin/database-ddl'
      preLoaderRoute: typeof AdminDatabaseDdlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/creators': {
      id: '/admin/creators'
      path: '/admin/creators'
      fullPath: '/admin/creators'
      preLoaderRoute: typeof AdminCreatorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing-plans': {
      id: '/admin/billing-plans'
      path: '/admin/billing-plans'
      fullPath: '/admin/billing-plans'
      preLoaderRoute: typeof AdminBillingPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/avatars': {
      id: '/admin/avatars'
      path: '/admin/avatars'
      fullPath: '/admin/avatars'
      preLoaderRoute: typeof AdminAvatarsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/app-version': {
      id: '/admin/app-version'
      path: '/admin/app-version'
      fullPath: '/admin/app-version'
      preLoaderRoute: typeof AdminAppVersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/api': {
      id: '/admin/api'
      path: '/admin/api'
      fullPath: '/admin/api'
      preLoaderRoute: typeof AdminApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai': {
      id: '/admin/ai'
      path: '/admin/ai'
      fullPath: '/admin/ai'
      preLoaderRoute: typeof AdminAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account_/cancel': {
      id: '/account_/cancel'
      path: '/account/cancel'
      fullPath: '/account/cancel'
      preLoaderRoute: typeof AccountCancelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account_/billing': {
      id: '/account_/billing'
      path: '/account/billing'
      fullPath: '/account/billing'
      preLoaderRoute: typeof AccountBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$section/': {
      id: '/help/$section/'
      path: '/help/$section'
      fullPath: '/help/$section/'
      preLoaderRoute: typeof HelpSectionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/$category/': {
      id: '/faq/$category/'
      path: '/faq/$category'
      fullPath: '/faq/$category/'
      preLoaderRoute: typeof FaqCategoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/stickers/': {
      id: '/admin/stickers/'
      path: '/admin/stickers'
      fullPath: '/admin/stickers/'
      preLoaderRoute: typeof AdminStickersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/sms/': {
      id: '/admin/sms/'
      path: '/admin/sms'
      fullPath: '/admin/sms/'
      preLoaderRoute: typeof AdminSmsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/signing/': {
      id: '/admin/signing/'
      path: '/admin/signing'
      fullPath: '/admin/signing/'
      preLoaderRoute: typeof AdminSigningIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/seed-data/': {
      id: '/admin/seed-data/'
      path: '/admin/seed-data'
      fullPath: '/admin/seed-data/'
      preLoaderRoute: typeof AdminSeedDataIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports/': {
      id: '/admin/reports/'
      path: '/admin/reports'
      fullPath: '/admin/reports/'
      preLoaderRoute: typeof AdminReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/push/': {
      id: '/admin/push/'
      path: '/admin/push'
      fullPath: '/admin/push/'
      preLoaderRoute: typeof AdminPushIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/occasions/': {
      id: '/admin/occasions/'
      path: '/admin/occasions'
      fullPath: '/admin/occasions/'
      preLoaderRoute: typeof AdminOccasionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/newsletters/': {
      id: '/admin/newsletters/'
      path: '/admin/newsletters'
      fullPath: '/admin/newsletters/'
      preLoaderRoute: typeof AdminNewslettersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/moderated-images/': {
      id: '/admin/moderated-images/'
      path: '/admin/moderated-images'
      fullPath: '/admin/moderated-images/'
      preLoaderRoute: typeof AdminModeratedImagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/media/': {
      id: '/admin/media/'
      path: '/admin/media'
      fullPath: '/admin/media/'
      preLoaderRoute: typeof AdminMediaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/knowledge/': {
      id: '/admin/knowledge/'
      path: '/admin/knowledge'
      fullPath: '/admin/knowledge/'
      preLoaderRoute: typeof AdminKnowledgeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/images/': {
      id: '/admin/images/'
      path: '/admin/images'
      fullPath: '/admin/images/'
      preLoaderRoute: typeof AdminImagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/gift-cards/': {
      id: '/admin/gift-cards/'
      path: '/admin/gift-cards'
      fullPath: '/admin/gift-cards/'
      preLoaderRoute: typeof AdminGiftCardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email/': {
      id: '/admin/email/'
      path: '/admin/email'
      fullPath: '/admin/email/'
      preLoaderRoute: typeof AdminEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/docs/': {
      id: '/admin/docs/'
      path: '/admin/docs'
      fullPath: '/admin/docs/'
      preLoaderRoute: typeof AdminDocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/disputes/': {
      id: '/admin/disputes/'
      path: '/admin/disputes'
      fullPath: '/admin/disputes/'
      preLoaderRoute: typeof AdminDisputesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/dispatch-monitor/': {
      id: '/admin/dispatch-monitor/'
      path: '/admin/dispatch-monitor'
      fullPath: '/admin/dispatch-monitor/'
      preLoaderRoute: typeof AdminDispatchMonitorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/countries/': {
      id: '/admin/countries/'
      path: '/admin/countries'
      fullPath: '/admin/countries/'
      preLoaderRoute: typeof AdminCountriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/contacts/': {
      id: '/admin/contacts/'
      path: '/admin/contacts'
      fullPath: '/admin/contacts/'
      preLoaderRoute: typeof AdminContactsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/codes/': {
      id: '/admin/codes/'
      path: '/admin/codes'
      fullPath: '/admin/codes/'
      preLoaderRoute: typeof AdminCodesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/categories/': {
      id: '/admin/categories/'
      path: '/admin/categories'
      fullPath: '/admin/categories/'
      preLoaderRoute: typeof AdminCategoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/cards/': {
      id: '/admin/cards/'
      path: '/admin/cards'
      fullPath: '/admin/cards/'
      preLoaderRoute: typeof AdminCardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/backgrounds/': {
      id: '/admin/backgrounds/'
      path: '/admin/backgrounds'
      fullPath: '/admin/backgrounds/'
      preLoaderRoute: typeof AdminBackgroundsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/ticket/$token': {
      id: '/support/ticket/$token'
      path: '/support/ticket/$token'
      fullPath: '/support/ticket/$token'
      preLoaderRoute: typeof SupportTicketTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders_/holiday_/add': {
      id: '/reminders_/holiday_/add'
      path: '/reminders/holiday/add'
      fullPath: '/reminders/holiday/add'
      preLoaderRoute: typeof RemindersHolidayAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders_/birthday_/more': {
      id: '/reminders_/birthday_/more'
      path: '/reminders/birthday/more'
      fullPath: '/reminders/birthday/more'
      preLoaderRoute: typeof RemindersBirthdayMoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders_/birthday_/add': {
      id: '/reminders_/birthday_/add'
      path: '/reminders/birthday/add'
      fullPath: '/reminders/birthday/add'
      preLoaderRoute: typeof RemindersBirthdayAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lists/view/$id': {
      id: '/lists/view/$id'
      path: '/lists/view/$id'
      fullPath: '/lists/view/$id'
      preLoaderRoute: typeof ListsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/linked/requests/$id': {
      id: '/linked/requests/$id'
      path: '/linked/requests/$id'
      fullPath: '/linked/requests/$id'
      preLoaderRoute: typeof LinkedRequestsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$section/$article': {
      id: '/help/$section/$article'
      path: '/help/$section/$article'
      fullPath: '/help/$section/$article'
      preLoaderRoute: typeof HelpSectionArticleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq/$category/$article': {
      id: '/faq/$category/$article'
      path: '/faq/$category/$article'
      fullPath: '/faq/$category/$article'
      preLoaderRoute: typeof FaqCategoryArticleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copy/read/$slug': {
      id: '/copy/read/$slug'
      path: '/copy/read/$slug'
      fullPath: '/copy/read/$slug'
      preLoaderRoute: typeof CopyReadSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/view/$cardId': {
      id: '/card/view/$cardId'
      path: '/card/view/$cardId'
      fullPath: '/card/view/$cardId'
      preLoaderRoute: typeof CardViewCardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/send/create': {
      id: '/card/send/create'
      path: '/card/send/create'
      fullPath: '/card/send/create'
      preLoaderRoute: typeof CardSendCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/read/$slug': {
      id: '/card/read/$slug'
      path: '/card/read/$slug'
      fullPath: '/card/read/$slug'
      preLoaderRoute: typeof CardReadSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/birthday_/request_/howto': {
      id: '/birthday_/request_/howto'
      path: '/birthday/request/howto'
      fullPath: '/birthday/request/howto'
      preLoaderRoute: typeof BirthdayRequestHowtoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/$id': {
      id: '/admin/users/$id'
      path: '/admin/users/$id'
      fullPath: '/admin/users/$id'
      preLoaderRoute: typeof AdminUsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/seed-data/$type': {
      id: '/admin/seed-data/$type'
      path: '/admin/seed-data/$type'
      fullPath: '/admin/seed-data/$type'
      preLoaderRoute: typeof AdminSeedDataTypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports/explore': {
      id: '/admin/reports/explore'
      path: '/admin/reports/explore'
      fullPath: '/admin/reports/explore'
      preLoaderRoute: typeof AdminReportsExploreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/push/$id': {
      id: '/admin/push/$id'
      path: '/admin/push/$id'
      fullPath: '/admin/push/$id'
      preLoaderRoute: typeof AdminPushIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/occasions/$id': {
      id: '/admin/occasions/$id'
      path: '/admin/occasions/$id'
      fullPath: '/admin/occasions/$id'
      preLoaderRoute: typeof AdminOccasionsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/newsletters/$issueId': {
      id: '/admin/newsletters/$issueId'
      path: '/admin/newsletters/$issueId'
      fullPath: '/admin/newsletters/$issueId'
      preLoaderRoute: typeof AdminNewslettersIssueIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/moderation/$reportId': {
      id: '/admin/moderation/$reportId'
      path: '/$reportId'
      fullPath: '/admin/moderation/$reportId'
      preLoaderRoute: typeof AdminModerationReportIdRouteImport
      parentRoute: typeof AdminModerationRoute
    }
    '/admin/moderated-images/$id': {
      id: '/admin/moderated-images/$id'
      path: '/admin/moderated-images/$id'
      fullPath: '/admin/moderated-images/$id'
      preLoaderRoute: typeof AdminModeratedImagesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/media/$id': {
      id: '/admin/media/$id'
      path: '/admin/media/$id'
      fullPath: '/admin/media/$id'
      preLoaderRoute: typeof AdminMediaIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/images/$id': {
      id: '/admin/images/$id'
      path: '/admin/images/$id'
      fullPath: '/admin/images/$id'
      preLoaderRoute: typeof AdminImagesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/gift-cards/$giftCardId': {
      id: '/admin/gift-cards/$giftCardId'
      path: '/admin/gift-cards/$giftCardId'
      fullPath: '/admin/gift-cards/$giftCardId'
      preLoaderRoute: typeof AdminGiftCardsGiftCardIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email/$id': {
      id: '/admin/email/$id'
      path: '/admin/email/$id'
      fullPath: '/admin/email/$id'
      preLoaderRoute: typeof AdminEmailIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/email-audit/$id': {
      id: '/admin/email-audit/$id'
      path: '/admin/email-audit/$id'
      fullPath: '/admin/email-audit/$id'
      preLoaderRoute: typeof AdminEmailAuditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/disputes/$id': {
      id: '/admin/disputes/$id'
      path: '/admin/disputes/$id'
      fullPath: '/admin/disputes/$id'
      preLoaderRoute: typeof AdminDisputesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/contacts/$id': {
      id: '/admin/contacts/$id'
      path: '/admin/contacts/$id'
      fullPath: '/admin/contacts/$id'
      preLoaderRoute: typeof AdminContactsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/codes/$codeId': {
      id: '/admin/codes/$codeId'
      path: '/admin/codes/$codeId'
      fullPath: '/admin/codes/$codeId'
      preLoaderRoute: typeof AdminCodesCodeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/categories/$id': {
      id: '/admin/categories/$id'
      path: '/admin/categories/$id'
      fullPath: '/admin/categories/$id'
      preLoaderRoute: typeof AdminCategoriesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/cards/$id': {
      id: '/admin/cards/$id'
      path: '/admin/cards/$id'
      fullPath: '/admin/cards/$id'
      preLoaderRoute: typeof AdminCardsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/backgrounds/$id': {
      id: '/admin/backgrounds/$id'
      path: '/admin/backgrounds/$id'
      fullPath: '/admin/backgrounds/$id'
      preLoaderRoute: typeof AdminBackgroundsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reminders_/birthday_/add_/manual': {
      id: '/reminders_/birthday_/add_/manual'
      path: '/reminders/birthday/add/manual'
      fullPath: '/reminders/birthday/add/manual'
      preLoaderRoute: typeof RemindersBirthdayAddManualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/view/$cardId_/$slug': {
      id: '/card/view/$cardId_/$slug'
      path: '/card/view/$cardId/$slug'
      fullPath: '/card/view/$cardId/$slug'
      preLoaderRoute: typeof CardViewCardIdSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/sign/view/$slug': {
      id: '/card/sign/view/$slug'
      path: '/card/sign/view/$slug'
      fullPath: '/card/sign/view/$slug'
      preLoaderRoute: typeof CardSignViewSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/sign/edit/$slug': {
      id: '/card/sign/edit/$slug'
      path: '/card/sign/edit/$slug'
      fullPath: '/card/sign/edit/$slug'
      preLoaderRoute: typeof CardSignEditSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/share/view/$slug': {
      id: '/card/share/view/$slug'
      path: '/card/share/view/$slug'
      fullPath: '/card/share/view/$slug'
      preLoaderRoute: typeof CardShareViewSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/card/send/view/$slug': {
      id: '/card/send/view/$slug'
      path: '/card/send/view/$slug'
      fullPath: '/card/send/view/$slug'
      preLoaderRoute: typeof CardSendViewSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reports/d/$slug': {
      id: '/admin/reports/d/$slug'
      path: '/admin/reports/d/$slug'
      fullPath: '/admin/reports/d/$slug'
      preLoaderRoute: typeof AdminReportsDSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminModerationRouteChildren {
  AdminModerationReportIdRoute: typeof AdminModerationReportIdRoute
}

const AdminModerationRouteChildren: AdminModerationRouteChildren = {
  AdminModerationReportIdRoute: AdminModerationReportIdRoute,
}

const AdminModerationRouteWithChildren = AdminModerationRoute._addFileChildren(
  AdminModerationRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRoute,
  Address_bookRoute: Address_bookRoute,
  AuthRoute: AuthRoute,
  CalendarRoute: CalendarRoute,
  Change_passwordRoute: Change_passwordRoute,
  CompanyRoute: CompanyRoute,
  ContactRoute: ContactRoute,
  EmailLinkRoute: EmailLinkRoute,
  EmailVerifyRoute: EmailVerifyRoute,
  Email_settingsRoute: Email_settingsRoute,
  ForgotRoute: ForgotRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  Happy_birthdayRoute: Happy_birthdayRoute,
  HomeRoute: HomeRoute,
  InfographicRoute: InfographicRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  PaymentRoute: PaymentRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  RemindersRoute: RemindersRoute,
  RemindersPrintViewRoute: RemindersPrintViewRoute,
  SafetyRoute: SafetyRoute,
  TeamRoute: TeamRoute,
  TermsRoute: TermsRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  VerifyRoute: VerifyRoute,
  AccountBillingRoute: AccountBillingRoute,
  AccountCancelRoute: AccountCancelRoute,
  AdminAiRoute: AdminAiRoute,
  AdminApiRoute: AdminApiRoute,
  AdminAppVersionRoute: AdminAppVersionRoute,
  AdminAvatarsRoute: AdminAvatarsRoute,
  AdminBillingPlansRoute: AdminBillingPlansRoute,
  AdminCreatorsRoute: AdminCreatorsRoute,
  AdminDatabaseDdlRoute: AdminDatabaseDdlRoute,
  AdminDeliverabilityRoute: AdminDeliverabilityRoute,
  AdminEmailLookupRoute: AdminEmailLookupRoute,
  AdminModerationRoute: AdminModerationRouteWithChildren,
  AdminOfflinePaymentsRoute: AdminOfflinePaymentsRoute,
  AdminPopularNamesRoute: AdminPopularNamesRoute,
  AdminQueryRoute: AdminQueryRoute,
  AdminRecoRoute: AdminRecoRoute,
  AdminSchedulerRoute: AdminSchedulerRoute,
  AdminSchemaRoute: AdminSchemaRoute,
  AdminScriptsRoute: AdminScriptsRoute,
  AdminSentryRoute: AdminSentryRoute,
  AdminServersRoute: AdminServersRoute,
  AdminSupportRoute: AdminSupportRoute,
  AdminSuppressionsRoute: AdminSuppressionsRoute,
  AdminTagsRoute: AdminTagsRoute,
  AdminTrendingRoute: AdminTrendingRoute,
  AdminVerifyRoute: AdminVerifyRoute,
  AdminVideosRoute: AdminVideosRoute,
  AdminWebsocketsRoute: AdminWebsocketsRoute,
  AnniversaryBrowseRoute: AnniversaryBrowseRoute,
  AnniversaryGiftRoute: AnniversaryGiftRoute,
  Bd4MagicRoute: Bd4MagicRoute,
  Bd5MagicRoute: Bd5MagicRoute,
  Bd6MagicRoute: Bd6MagicRoute,
  Bd7MagicRoute: Bd7MagicRoute,
  BdayMagicRoute: BdayMagicRoute,
  BillingReturnRoute: BillingReturnRoute,
  BirthdayBrowseRoute: BirthdayBrowseRoute,
  CardCreateRoute: CardCreateRoute,
  CardsSplatRoute: CardsSplatRoute,
  CardsBrowseRoute: CardsBrowseRoute,
  ContactsImportRoute: ContactsImportRoute,
  DobTokenRoute: DobTokenRoute,
  GiftSdkHostRoute: GiftSdkHostRoute,
  HolidayBrowseRoute: HolidayBrowseRoute,
  ListsTokenRoute: ListsTokenRoute,
  ListsNewRoute: ListsNewRoute,
  MycardsTypeRoute: MycardsTypeRoute,
  NameNameRoute: NameNameRoute,
  RemindersAddRoute: RemindersAddRoute,
  RemindersHolidayRoute: RemindersHolidayRoute,
  SSignTokenRoute: SSignTokenRoute,
  SharesTokenRoute: SharesTokenRoute,
  AdminIndexRoute: AdminIndexRoute,
  CardsIndexRoute: CardsIndexRoute,
  FaqIndexRoute: FaqIndexRoute,
  HelpIndexRoute: HelpIndexRoute,
  LinkedIndexRoute: LinkedIndexRoute,
  MycardsIndexRoute: MycardsIndexRoute,
  NameIndexRoute: NameIndexRoute,
  SupportIndexRoute: SupportIndexRoute,
  AdminBackgroundsIdRoute: AdminBackgroundsIdRoute,
  AdminCardsIdRoute: AdminCardsIdRoute,
  AdminCategoriesIdRoute: AdminCategoriesIdRoute,
  AdminCodesCodeIdRoute: AdminCodesCodeIdRoute,
  AdminContactsIdRoute: AdminContactsIdRoute,
  AdminDisputesIdRoute: AdminDisputesIdRoute,
  AdminEmailAuditIdRoute: AdminEmailAuditIdRoute,
  AdminEmailIdRoute: AdminEmailIdRoute,
  AdminGiftCardsGiftCardIdRoute: AdminGiftCardsGiftCardIdRoute,
  AdminImagesIdRoute: AdminImagesIdRoute,
  AdminMediaIdRoute: AdminMediaIdRoute,
  AdminModeratedImagesIdRoute: AdminModeratedImagesIdRoute,
  AdminNewslettersIssueIdRoute: AdminNewslettersIssueIdRoute,
  AdminOccasionsIdRoute: AdminOccasionsIdRoute,
  AdminPushIdRoute: AdminPushIdRoute,
  AdminReportsExploreRoute: AdminReportsExploreRoute,
  AdminSeedDataTypeRoute: AdminSeedDataTypeRoute,
  AdminUsersIdRoute: AdminUsersIdRoute,
  BirthdayRequestHowtoRoute: BirthdayRequestHowtoRoute,
  CardReadSlugRoute: CardReadSlugRoute,
  CardSendCreateRoute: CardSendCreateRoute,
  CardViewCardIdRoute: CardViewCardIdRoute,
  CopyReadSlugRoute: CopyReadSlugRoute,
  FaqCategoryArticleRoute: FaqCategoryArticleRoute,
  HelpSectionArticleRoute: HelpSectionArticleRoute,
  LinkedRequestsIdRoute: LinkedRequestsIdRoute,
  ListsViewIdRoute: ListsViewIdRoute,
  RemindersBirthdayAddRoute: RemindersBirthdayAddRoute,
  RemindersBirthdayMoreRoute: RemindersBirthdayMoreRoute,
  RemindersHolidayAddRoute: RemindersHolidayAddRoute,
  SupportTicketTokenRoute: SupportTicketTokenRoute,
  AdminBackgroundsIndexRoute: AdminBackgroundsIndexRoute,
  AdminCardsIndexRoute: AdminCardsIndexRoute,
  AdminCategoriesIndexRoute: AdminCategoriesIndexRoute,
  AdminCodesIndexRoute: AdminCodesIndexRoute,
  AdminContactsIndexRoute: AdminContactsIndexRoute,
  AdminCountriesIndexRoute: AdminCountriesIndexRoute,
  AdminDispatchMonitorIndexRoute: AdminDispatchMonitorIndexRoute,
  AdminDisputesIndexRoute: AdminDisputesIndexRoute,
  AdminDocsIndexRoute: AdminDocsIndexRoute,
  AdminEmailIndexRoute: AdminEmailIndexRoute,
  AdminGiftCardsIndexRoute: AdminGiftCardsIndexRoute,
  AdminImagesIndexRoute: AdminImagesIndexRoute,
  AdminKnowledgeIndexRoute: AdminKnowledgeIndexRoute,
  AdminMediaIndexRoute: AdminMediaIndexRoute,
  AdminModeratedImagesIndexRoute: AdminModeratedImagesIndexRoute,
  AdminNewslettersIndexRoute: AdminNewslettersIndexRoute,
  AdminOccasionsIndexRoute: AdminOccasionsIndexRoute,
  AdminPushIndexRoute: AdminPushIndexRoute,
  AdminReportsIndexRoute: AdminReportsIndexRoute,
  AdminSeedDataIndexRoute: AdminSeedDataIndexRoute,
  AdminSigningIndexRoute: AdminSigningIndexRoute,
  AdminSmsIndexRoute: AdminSmsIndexRoute,
  AdminStickersIndexRoute: AdminStickersIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  FaqCategoryIndexRoute: FaqCategoryIndexRoute,
  HelpSectionIndexRoute: HelpSectionIndexRoute,
  AdminReportsDSlugRoute: AdminReportsDSlugRoute,
  CardSendViewSlugRoute: CardSendViewSlugRoute,
  CardShareViewSlugRoute: CardShareViewSlugRoute,
  CardSignEditSlugRoute: CardSignEditSlugRoute,
  CardSignViewSlugRoute: CardSignViewSlugRoute,
  CardViewCardIdSlugRoute: CardViewCardIdSlugRoute,
  RemindersBirthdayAddManualRoute: RemindersBirthdayAddManualRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
